import {
  AutoComplete,
  Breadcrumb,
  Input,
  message,
  Radio,
  Select,
  Space,
  Spin,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AddIcon,
  BackIcon,
  CloseIconSearch,
  DelivLogo,
  DelivStep,
  OrderLogo,
  OrderStep,
  ReviewLogo,
  SearchIcon,
  TotalStep,
} from "../../../asset";
import PrimaryButton from "../../../component/button/PrimaryButton";
import SecondaryButton from "../../../component/button/SecondaryButton";
import MapsRoute from "../../../component/maps/MapsRoute";
import { ROUTES } from "../../../constant/routeConstant";

import style from "./OrderRequestAdd.module.css";
import Geocode from "react-geocode";
import _, { update } from "lodash";
import { onChanged } from "../../../util/Util";
import { useDispatch, useSelector } from "react-redux";
import { validOrder } from "./validation";
import Accordion from "../../../component/accordion/Accordion";
import MSSSkillset from "../../../component/select/MSSSkillset";
import { GROLOG_ORDER_URL, GROLOG_URL } from "../../../constant/apiConstant";
import axios from "axios";
import ModalConfirmLeave from "../../../component/modal/ModalConfirmLeave";
import ModalSuccessAdd from "../../../component/modal/ModalSuccessAdd";
import MSSTemperatureCategory from "../../../component/select/MSSTemperatureCategory";
import ModalMaps from "../../../component/modal/ModalMaps";
import MapsSmall from "../../../component/maps/MapsSmall";
import { validDriver } from "../../master/fleet/driver/validation";
import { validCustomer } from "../../master/customer/validation";
import ModalFailedDelete from "../../../component/modal/ModalFailedDelete";
import { REGEX_CONSTANT } from "../../../constant/regexConstant";
import { dropdownCustom, LoadingOption, selectOption } from "../../../component/select/SelectOption";

const OrderRequestAdd = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [form, setForm] = useState({});
  const location = useLocation();
  const [directions, setDirections] = useState([]);
  const [filter, setFilter] = useState("");
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [weightPallet, setWeightPallet] = useState(0);
  const [widthPallet, setWidthPallet] = useState(0);
  const [lengthPallet, setLengthPallet] = useState(0);
  const [heightPallet, setHeightPallet] = useState(0);
  const [error, setError] = useState();
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const dispatch = useDispatch();
  const [isData, setIsData] = useState([]);
  const [index, setIndex] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [load, setLoad] = useState(false);
  const [addressFormat, setAddressFormat] = useState([]);
  const [change, setChange] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [changeOrder, setChangeOrder] = useState(true);
  const [add, setAdd] = useState(true);
  const [addAdr, setAddAdr] = useState(true);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [changeItem, setChangeItem] = useState(true);
  const [longlat, setLonglat] = useState([]);
  const [custCat, setCustCat] = useState("existing");
  const [customer, setCustomer] = useState([]);
  const [country, setCountry] = useState([]);
  const [island, setIsland] = useState([]);
  const [province, setProvince] = useState([]);
  const [district, setDistrict] = useState([]);
  const [subdistrict, setSubdistrict] = useState([]);
  const [urbanvillage, setUrbanvillage] = useState([]);
  const [postalcode, setPostalcode] = useState([]);
  const [title, setTitle] = useState([]);
  const [pallet, setPallet] = useState([]);
  const [isOpenMaps, setIsOpenMaps] = useState(false);
  const [deliveryType, setDeliveryType] = useState([]);
  const [DTList, setDTList] = useState([])
  const [changeAddress, setChangeAddress] = useState(true);
  const [isDataAdr, setIsDataAdr] = useState([]);
  const [detail, setDetail] = useState();
  const [c, setC] = useState("");
  const [i, setI] = useState("");
  const [p, setP] = useState("");
  const [d, setD] = useState("");
  const [s, setS] = useState("");
  const [u, setU] = useState("");
  const [pc, setPc] = useState("");
  const [addressSubmit, setAddressSubmit] = useState([]);
  const [skillset, setSkillset] = useState([]);
  const [temp, setTemp] = useState([]);
  const [pallet2, setPallet2] = useState([])
  const [radius, setRadius] = useState(0);
  const [isMax, setIsMax] = useState(false);
  const [details, setDetails] = useState([]);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [errPostal, setErrPostal] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [pageDelivery, setPageDelivery] = useState(1);
  const [limitDelivery, setLimitDelivery] = useState(10);
  const [pagePallet, setPagePallet] = useState(1);
  const [limitPallet, setLimitPallet] = useState(10);
  const [pageCountry, setPageCountry] = useState(1);
  const [limitCountry, setLimitCountry] = useState(10);
  // const [filter, setFilter] = useState("");
  const [pageProvince, setPageProvince] = useState(1);
  const [limitProvince, setLimitProvince] = useState(10);
  const [filterProvince, setFilterProvince] = useState("");
  const [pageDistrict, setPageDistrict] = useState(1);
  const [limitDistrict, setLimitDistrict] = useState(10);
  const [filterDistrict, setFilterDistrict] = useState("");
  const [pageSubdistrict, setPageSubdistrict] = useState(1);
  const [limitSubdistrict, setLimitSubdistrict] = useState(10);
  const [filterSubdistrict, setFilterSubdistrict] = useState("");
  const [pageUrbanvillage, setPageUrbanvillage] = useState(1);
  const [limitUrbanvillage, setLimitUrbanvillage] = useState(10);
  const [filterUrbanvillage, setFilterUrbanvillage] = useState("");
  const [pageSkillset, setPageSkillset] = useState(1);
  const [limitSkillset, setLimitSkillset] = useState(10);
  const [filterSkillset, setFilterSkillset] = useState("");
  const [pageTemp, setPageTemp] = useState(1);
  const [limitTemp, setLimitTemp] = useState(10);
  const [filterTemp, setFilterTemp] = useState("");
  const [pageCustomer, setPageCustomer] = useState(1);
  const [limitCustomer, setLimitCustomer] = useState(10);
  const [filterCustomer, setFilterCustomer] = useState("");
  const [errAddress,setErrAddress]=useState("")
  const [prioDeliv, setPrioDeliv] = useState([
    { value: 1, label: "Urgent" },
    { value: 2, label: "High" },
    { value: 3, label: "Medium" },
    { value: 4, label: "Low" },
  ]);
  const api = GROLOG_URL;
  // const [skillset, setSkillset] = useState({
  //   flagCheckAll: true,
  //   isExclude: false,
  //   data: [],
  // });
  // const [temp, setTemp] = useState({
  //   flagCheckAll: true,
  //   isExclude: false,
  //   data: [],
  // });

  // const getDistance = () => {
  //   var distanceService = new window.google.maps.DistanceMatrixService();

  //   // Define the origin and destination coordinates
  //   var origin = new window.google.maps.LatLng(Number(detail?.depot_profile?.depot_latitude), Number(detail?.depot_profile?.depot_longitude));
  //   var destination = new window.google.maps.LatLng(Number(isData[index]?.latitude), Number(isData[index]?.longitude));

  //   // Create a request object
  //   var request = {
  //     origins: [origin],
  //     destinations: [destination],
  //     travelMode: "DRIVING",
  //     unitSystem: window.google.maps.UnitSystem.METRIC,
  //   };

  //   // Call the getDistanceMatrix method of the DistanceMatrixService to get the distance
  //   distanceService.getDistanceMatrix(request, function (response, status) {
  //     if (status == "OK") {
  //       var distance = response.rows[0].elements[0].distance.text;
  //       console.log("Distance:", distance);
  //     } else {
  //       console.log("Error:", status);
  //     }
  //   });
  // };

  const geocode = (address, condition) => {
    setLoad(true);
    Geocode.setApiKey("AIzaSyC3m-M8TJAIH96lzjN2gDXHpyO1A2tTbsk");
    Geocode.fromAddress(address).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        // const newDetail = [...form];
        setForm((prevsValue) => {
          return {
            ...prevsValue,
            ["longitude"]: lng.toString(),
            ["latitude"]: lat.toString(),
          };
        });
        setErrAddress("")
        if (form?.address && !condition) {
          getPostalCode(lat, lng);
        }
        setLoad(false);
        // newDetail["longitude"] = lng.toString();
        // newDetail["latitude"] = lat.toString();
        // setForm(newDetail);
      },
      (error) => {
        setErrAddress("Address not found, please enter more specific or valid address")
      }
    );
  };

  const actionBlur = (i) => {
    // if (addressFormat < 0) {
    // let lnglat =
    //   c + "," + p + "," + d + "," + s + "," + u + "," + form?.depot_address_1;
    let lnglat = form?.address
    geocode(lnglat);
    if(index === "N" || custCat === "new"){

      getDistance() 
    }
    // }
  };

  const onBlurPostal = () => {
    getRegionByPostalCode(form?.postal_code, s,u);
  };

  const getPostalCode = (latitude, longitude) => {
    const geocoder = new window.google.maps.Geocoder();
    const latLng = new window.google.maps.LatLng(latitude, longitude);

    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
        for (let i = 0; i < results[0].address_components.length; i++) {
          const component = results[0].address_components[i];
          if (component.types.includes("postal_code")) {
            let eror = validCustomer("postal_code", component.long_name, t);
            setError({ ...error, ...eror });
            setForm((prevsValue) => {
              return {
                ...prevsValue,
                ["postal_code"]: Number(component.long_name),
              };
            });
            if(form?.address){
              getRegionByPostalCode(component.long_name, s, u);
              }
            return; // Exit the loop if postal code is found
          }
        }
        setForm((prevsValue) => {
          return {
            ...prevsValue,
            ["postal_code"]: "",
          };
        });
      } else {
      }
    });
  };
  const getRegionByPostalCode = async (code, subDistrict, urbanVillage) => {
    try {
      // let region = await doGets(`/postal_code/${code}`, token);
      let data ={
        "sub_district": subDistrict,
        "urban_village": urbanVillage
      }
      let region = await doGetPostalCode(`/postal_code/${code}`, token, data);
      let reg = region?.data?.payload?.data;
      getListCountry(1, 100, "");
      getListProvince(reg?.country_id, 1, 100, "");
      getListDistrict(reg?.country_id, reg?.province_id, 1, 100, "");
      getListSubdistrict(reg?.country_id, reg?.district_id, 1, 100, "");
      getListUrbanvillage(reg?.country_id, reg?.sub_district_id, 1, 100, "");
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          ["country"]: reg?.country_id,
          ["province"]: reg?.province_id,
          ["district"]: reg?.district_id,
          ["sub_district"]: reg?.sub_district_id,
          ["urban_village"]: reg?.urban_village_id,
        };
      });
      setErrPostal("");
      let lnglat =
        reg?.country_name +
        "," +
        reg?.province_name +
        "," +
        reg?.district_name +
        "," +
        reg?.sub_district_name +
        "," +
        reg?.urban_village_name +
        "," +
        code;

      // geocode(lnglat, index);
    } catch (err) {
      try {
        // let region = await doGets(`/postal_code/${code}`, token);
        let data ={
          "sub_district": "",
          "urban_village": ""
        }
        let region = await doGetPostalCode(`/postal_code/${code}`, token, data);
        let reg = region?.data?.payload?.data;
        getListCountry(1, 100, "");
        getListProvince(reg?.country_id, 1, 100, "");
        getListDistrict(reg?.country_id, reg?.province_id, 1, 100, "");
        getListSubdistrict(reg?.country_id, reg?.district_id, 1, 100, "");
        getListUrbanvillage(reg?.country_id, reg?.sub_district_id, 1, 100, "");
        setForm((prevsValue) => {
          return {
            ...prevsValue,
            ["country"]: reg?.country_id,
            ["province"]: reg?.province_id,
            ["district"]: reg?.district_id,
            ["sub_district"]: reg?.sub_district_id,
            ["urban_village"]: reg?.urban_village_id,
          };
        });
        setErrPostal("");
        let lnglat =
          reg?.country_name +
          "," +
          reg?.province_name +
          "," +
          reg?.district_name +
          "," +
          reg?.sub_district_name +
          "," +
          reg?.urban_village_name +
          "," +
          code;
  
        // geocode(lnglat, index);
      } catch (err) {
        if (err.response.data.payload.code === "E-4-CMD-DTO-004") {
          setErrPostal("Postal Code not found");
        }
      }
    }
  };

  const doGetPostalCode = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = GROLOG_URL + endpoint;
    const method = "POST";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (data) => {
    // setLoad(true);
    getListSkillset(1, 10, "");
    getListTemp(1, 10, "");
    getListCountry(1, 10, "");
    getCustomer(1, 10, "");
    getPallet(1, 10, "");
    // getDelivery(1, 10, "");
    getAddressFormat();
    let result = await doGets(
      `/depot-configuration/${location.state}?${param}`,
      token
    );
    setRadius(
      Number(
        result?.data?.payload?.data?.system_preferences?.max_range?.split(
          " "
        )[0]
      )
    );
    setDetails(result?.data?.payload?.data);
    let resParam = await doGets(
      `/grolog-parameter?page=1&limit=100&order=id asc&${param}`,
      token
    );
    let resDetail = await doGets(
      `/grolog-parameter/${resParam?.data?.payload?.data[
        resParam?.data?.payload?.data?.findIndex(
          (el) => el.parameter_code === "@MaxOrderRadius"
        )
      ]?.id
      }?${param}`,
      token
    );
    // setRadius(Number(resDetail?.data?.payload?.char_value));

    // setLoad(false);
  };

  const getAddressFormat = async () => {
    let res = await doGets(
      `/address-format-configuration?page=1&limit=10?${param}`,
      token
    );
    getListCountry();
    setAddressFormat(
      res?.data?.payload?.data?.ListAddressFormatConfiguration?.map(
        (el) => el?.mandatory
      )?.findIndex((cek) => cek === "No")
    );
  };

  const getListSkillset = async (page, limit, filter) => {
    const currentCountry = [...skillset];
    let init = await doGets(
      `/skill-set/initiate?filter=depot_id eq ${location.state}&${param}`,
      token
    );
    let res = await doGets(
      `/skill-set/dropdown?page=${page}&limit=${limit}&filter=depot_id eq ${location.state}${filter
        ? ", skillset_name lk " + filter
        :""
    }&${param}`,
      token
    );
    let list = [];
    res?.data?.payload?.data.map((el) => {
      list.push({
        id: el.id,
        value: el.value,
      });
    });
    setSkillset(selectOption(currentCountry, list, "value"));
  };

  const getListTemp = async (page, limit, filter) => {
    const currentCountry = [...temp];
    let init = await doGets(`/temperature-category/initiate?${param}`, token);
    let res = await doGets(
      `/temperature-category/dropdown?page=${page}&limit=${limit}${filter
        ? "&filter=skillset_name lk " + filter
        :""
    }&${param}`,
      token
    );
    let list = [];
    res?.data?.payload?.data.map((el) => {
      list.push({
        id: el.id,
        value: el.value,
      });
    });
    setTemp(selectOption(currentCountry, list, "value"));
  };

  const isZero = []
  const getListCountry = async (page, limit, filter) => {

    const currentCountry = [...country];
    let countrys = await doGets(
      `/country?page=${page}&limit=${limit}${filter ? `&filter=name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = countrys?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      setCountry(selectOption(currentCountry, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListIsland = async (id) => {
    let island = await doGets(
      `/island?page=1&limit=50&order=id&filter=country_id eq ${id}&${param}`,
      token
    );
    let list = [];
    island?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.name,
      });
    });
    setIsland(list);
  };

  const getListProvince = async (id, page, limit, filter, isChange) => {
    const currentProvince = [...province];
    let provinces = await doGets(
      `/province?page=${page}&limit=${limit}&filter=country_id eq ${id}${filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = provinces?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setProvince(selectOption(isZero, option, "value"));
      } else {
        setProvince(selectOption(currentProvince, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListDistrict = async (id, idprov, page, limit, filter, isChange) => {

    const currentDistrict = [...district];
    let districts = await doGets(
      `/district?page=${page}&limit=${limit}&filter=country_id eq ${id}, province_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setDistrict(selectOption(isZero, option, "value"));
      } else {
        setDistrict(selectOption(currentDistrict, option, "value"));
      } setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListSubdistrict = async (id, idprov, page, limit, filter, isChange) => {
    const currentSubdistrict = [...subdistrict];
    let districts = await doGets(
      `/sub_district?page=${page}&limit=${limit}&filter=country_id eq ${id}, district_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setSubdistrict(selectOption(isZero, option, "value"));
      } else {
        setSubdistrict(selectOption(currentSubdistrict, option, "value"));
      } setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListUrbanvillage = async (id, idprov, page, limit, filter, isChange) => {
    const currentUrbanvillage = [...urbanvillage];
    let districts = await doGets(
      `/urban_village?page=${page}&limit=${limit}&filter=country_id eq ${id}, sub_district_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setUrbanvillage(selectOption(isZero, option, "value"));
      } else {
        setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
      } setLoading(false);
    } else {
      setLoading(false);
    }
  };
  const onScrollDeliveryType = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageDelivery(pageDelivery + 1);
      target.scrollTo(0, target.scrollHeight);
      getDelivery(pageDelivery + 1, limitDelivery, "");
    }
  };

  const onChangeDeliveryType = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    let filterSearch = value && `${value}`;
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setDeliveryType([]);
      setPageDelivery(resetPage);
      setTimeout(() => {
        getDelivery(1, limitDelivery, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setDeliveryType([]);
      setFilter(resetFilter);
      setPageDelivery(resetPage);
      getDelivery(1, limitDelivery, filter);
    }
  };
  
  const onScrollTemp = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageTemp(pageTemp + 1);
      target.scrollTo(0, target.scrollHeight);
      getListTemp(pageTemp + 1, limitTemp, "");
    }
  };

  const onChangeTemp = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    let filterSearch = value && `${value}`;
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setTemp([]);
      setPageTemp(resetPage);
      setTimeout(() => {
        getListTemp(pageTemp + 1, limitTemp, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setTemp([]);
      setFilter(resetFilter);
      setPageTemp(resetPage);
      getListTemp(1, limitTemp, filter);
    }
  };

  const onScrollSkillset = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageSkillset(pageSkillset + 1);
      target.scrollTo(0, target.scrollHeight);
      getListSkillset(pageSkillset + 1, limitSkillset, "");
    }
  };

  const onChangeSkillset = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    let filterSearch = value && `${value}`;
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setSkillset([]);
      setPageSkillset(resetPage);
      setTimeout(() => {
        getListSkillset(pageSkillset + 1, limitSkillset, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setSkillset([]);
      setFilter(resetFilter);
      setPageSkillset(resetPage);
      getListSkillset(1, limitSkillset, filter);
    }
  };
  const onScrollPallet = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPagePallet(pagePallet + 1);
      target.scrollTo(0, target.scrollHeight);
      getPallet(pagePallet + 1, limitPallet, "");
    }
  };

  const onChangePallet = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    let filterSearch = value && `${value}`;
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setPallet([]);
      setPallet2([]);
      setPagePallet(resetPage);
      setTimeout(() => {
        getPallet(pagePallet + 1, limitPallet, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setPallet([]);
      setPallet2([]);
      setFilter(resetFilter);
      setPagePallet(resetPage);
      getPallet(1, limitPallet, filter);
    }
  };
  const onScrollCountry = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageCountry(pageCountry + 1);
      target.scrollTo(0, target.scrollHeight);
      getListCountry(pageCountry, limitCountry, "");
      // setTimeout(() => {
      //   getListCountry(pageCountry,limitCountry)
      // }, 256);
    }
  };

  const onChangeCountry = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setCountry([]);
      setPageCountry(resetPage);
      // this.setState(
      setTimeout(() => {
        getListCountry(pageCountry, limitCountry, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setCountry([]);
      setFilter(resetFilter);
      setPageCountry(resetPage);
      getListCountry(pageCountry, limitCountry, filter);
    }
  };

  const onScrollProvince = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageProvince(pageProvince + 1);
      target.scrollTo(0, target.scrollHeight);
      getListProvince(form?.country, pageProvince, limitProvince, "");
      // setTimeout(() => {
      //   getListProvince(pageProvince,limitProvince)
      // }, 256);
    }
  };

  const onChangeProvince = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setProvince([]);
      setPageProvince(resetPage);
      // this.setState(
      setTimeout(() => {
        getListProvince(form?.country, pageProvince, limitProvince, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setProvince([]);
      setFilter(resetFilter);
      setPageProvince(resetPage);
      getListProvince(form?.country, pageProvince, limitProvince, filter);
    }
  };

  const onScrollDistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageDistrict(pageDistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListDistrict(form?.country, form?.province, pageDistrict, limitDistrict, "");
      // setTimeout(() => {
      //   getListDistrict(pageDistrict,limitDistrict)
      // }, 256);
    }
  };

  const onChangeDistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setDistrict([]);
      setPageDistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListDistrict(form?.country, form?.province, pageDistrict, limitDistrict, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setDistrict([]);
      setFilter(resetFilter);
      setPageDistrict(resetPage);
      getListDistrict(form?.country, form?.province, pageDistrict, limitDistrict, filter);
    }
  };
  const onScrollSubdistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageSubdistrict(pageSubdistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListSubdistrict(form?.country, form?.district, pageSubdistrict, limitSubdistrict, "");
      // setTimeout(() => {
      //   getListSubdistrict(pageSubdistrict,limitSubdistrict)
      // }, 256);
    }
  };

  const onChangeSubdistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setSubdistrict([]);
      setPageSubdistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListSubdistrict(form?.country, form?.district, pageSubdistrict, limitSubdistrict, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setSubdistrict([]);
      setFilter(resetFilter);
      setPageSubdistrict(resetPage);
      getListSubdistrict(form?.country, form?.district, pageSubdistrict, limitSubdistrict, filter);
    }
  };
  const onScrollUrbanvillage = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageUrbanvillage(pageUrbanvillage + 1);
      target.scrollTo(0, target.scrollHeight);
      getListUrbanvillage(form?.country, isData[index]["sub_district_id"], pageUrbanvillage, limitUrbanvillage, "");
      // setTimeout(() => {
      //   getListUrbanvillage(pageUrbanvillage,limitUrbanvillage)
      // }, 256);
    }
  };

  const onChangeUrbanvillage = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setUrbanvillage([]);
      setPageUrbanvillage(resetPage);
      // this.setState(
      setTimeout(() => {
        getListUrbanvillage(form?.country, form?.sub_district, pageUrbanvillage, limitUrbanvillage, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setUrbanvillage([]);
      setFilter(resetFilter);
      setPageUrbanvillage(resetPage);
      getListUrbanvillage(form?.country, form?.sub_district, pageUrbanvillage, limitUrbanvillage, filter);
    }
  };
  const getListPostalCode = async (id, idprov) => {
    let district = await doGets(
      `/postal_code?page=1&limit=50&order=id&filter=urban_village_id eq ${idprov}&${param}`,
      token
    );
    let list = [];
    district?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.code,
      });
    });
    setPostalcode(list);
  };

  const getCustomer = async (page, limit, filter) => {
    const currentCountry = [...customer];
    let country = await doGets(
      `/customer?page=${page}&limit=${limit}&order=id asc&filter=depot_id eq ${location.state}${filter
        ? ", customer_name lk " + filter
        :""
    }&${param}`,
      token
    );
    let option = [];
    let list = country?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.customer_id,
          value: element.first_name,
        };
        option.push(data);
      }
      // if (option.length>=1) {
        setCustomer(selectOption(currentCountry, option, "value"));
      // } else {
      //   setCountry(selectOption(isZero, option, "value"));
      // }
      // setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const onScrollCustomer = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageCustomer(pageCustomer + 1);
      target.scrollTo(0, target.scrollHeight);
      getCustomer(pageCustomer, limitCustomer, "");
      // setTimeout(() => {
      //   getListCustomer(pageCustomer,limitCustomer)
      // }, 256);
    }
  };
  const onChangeCustomer = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value?.length >= 2) {
      setCustomer([]);
      setPageCustomer(resetPage);
      // this.setState(
      setTimeout(() => {
        getCustomer(pageCustomer, limitCustomer, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setCustomer([]);
      setFilter(resetFilter);
      setPageCustomer(resetPage);
      getCustomer(pageCustomer, limitCustomer, filter);
    }
  };

  const getPallet = async (page, limit, filter) => {
    const currentCountry = [...pallet2];
    let country = await doGets(
      `/pallet?page=${page}&limit=${limit}&order=id asc&filter=depot_id eq ${location.state}${filter
        ? ", pallet_name lk " + filter
        :""
    }&${param}`,
      token
    );
    let list = [];
    country?.data?.payload?.data.map((el) => {
      list.push({
        id: el.pallet_id,
        value: el.pallet_name,
        weight: el.weight,
        width: el?.width,
        length: el?.length,
        height: el?.height,
      });
    });
    setPallet(list);
    setPallet2(selectOption(currentCountry, list, "value"))
  };


  // const getDelivery = async (page, limit, filter) => {
    
  //   const currentCountry = [...deliveryType];
  //   let country = await doGets(
  //     `/delivery-type/dropdown-list?page=${page}&limit=${limit}&order=id asc${filter
  //       ? ", delivery_type lk " + filter
  //       :""
  //   }&${param}`,
  //     token
  //   );
  //   let list = [];
  //   country?.data?.payload?.data.map((el) => {
  //     list.push({
  //       id: el.id,
  //       value: el.value,
  //     });
  //   });
  //   // setDeliveryType(list);
  //   setDeliveryType(selectOption(currentCountry, list, "value"));
      
  // };
console.log("form", form,  (form?.address_id &&form?.address_id !== "N") ? detail?.customer_address[detail?.customer_address?.findIndex((el)=>el.address_id === form?.address_id)]?.longitude : form?.longitude)
  
  const getDelivery = async (page, limit, filter) => {
    let dataSend ={
      "shipping_cost":{
          "page" : page,
          "limit" : limit,
          "filter" : filter ? `delivery_type lk ${filter}` : "",
          "depot_id" : location.state,
          "total_weight" : subWeight?.reduce((acc, curr) => acc + curr),
          "total_volume" : subVol?.reduce((acc, curr) => acc + curr),
          "longitude" : (form?.address_id &&form?.address_id !== "N") ? detail?.customer_address[detail?.customer_address?.findIndex((el)=>el.address_id === form?.address_id)]?.longitude : form?.longitude ,
          "latitude" : (form?.address_id &&form?.address_id !== "N") ? detail?.customer_address[detail?.customer_address?.findIndex((el)=>el.address_id === form?.address_id)]?.latitude : form?.latitude
      }
  }
    const currentCountry = [...deliveryType];
    let country = await doPostDT(
      `/delivery-type/shipping-cost`,
      token, dataSend
    );
    let list = [];
    country?.data?.payload?.data.map((el) => {
      list.push({
        id: el.delivery_type_id,
        value: el.delivery_type,
      });
    });
    setDTList(country?.data?.payload?.data);
    setDeliveryType(selectOption(currentCountry, list, "value"));
      
  };

  const getCustomerDetail = async (value) => {
    let res = await doGets(`/customer/${value}`, token);
    setDetail(res?.data?.payload?.data);
    let list = [];
    res?.data?.payload?.data?.customer_address.map((el) => {
      list.push({
        recipient_name: el.recipient_name,
        recipient_phone: el.recipient_phone,
        address_id: el.address_id,
        updated_at: el.updated_at,
        country_id: el.countryId,
        province_id: el.provinceId,
        island_id: el.islandId,
        district_id: el.districtId,
        sub_district_id: el.subDistrictId,
        urban_village_id: el.urbanVillageId,
        postal_code: el.postal_code_id,
        longitude: el.longitude,
        latitude: el.latitude,
        hamlet: el.hamlet,
        neighbourhood: el.neighbourhood,
        address: el.address,
      });
    });
    // detail?.customer_address[0]?.address_id

    setForm((prevsValue) => {
      return {
        ...prevsValue,
        ["address_id"]:
          res?.data?.payload?.data?.customer_address[0]?.address_id,
      };
    });
    setAddressSubmit(list);
  };

  const clickCard = (i, open) => {
    setIndex(i);
    setIsOpen(isOpen ? false : true);
  };

  const removeItem = (i) => {
    let newDetail = [...isData];
    newDetail.splice(i, 1);
    setIsData(newDetail);
    setChangeItem(false);
    if (isData.length === 0 || isData.length - 1 === i) {
      setAdd(true);
    }
  };

  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  };

  const addItem = (i) => {
    if (isData[i]?.is_use_pallet === "Y") {
      if (
        isData[i]?.length >
        pallet[pallet.findIndex((obj) => obj.value === isData[i]?.pallet_id)]
          ?.length ||
        isData[i]?.width >
        pallet[pallet.findIndex((obj) => obj.value === isData[i]?.pallet_id)]
          ?.width
      ) {
        // setFailedModalOpen(true)
        // message.error(_.startCase("length or weight cannot more than pallet"));
      } else {
        let errors = {};
        let sub = isData[i];
        for (const key in sub) {
          const option = validOrder(key, sub[key], t);
          const currentError = option;
          errors = { ...currentError, ...errors };
        }
        setError(errors);
        if (validateSubmit(errors)) {
          let newDetail = [...isData];
          newDetail[i]["weight"] = parseFloat(isData[i]?.weight)
            newDetail[i]["width"] = parseFloat(isData[i]?.width)
            newDetail[i]["height"] = parseFloat(isData[i]?.height)
            newDetail[i]["length"] = parseFloat(isData[i]?.length)
            newDetail[i]["volume"] = parseFloat(isData[i]?.volume)
            newDetail[i]["subtotal_volume_per_item"] = parseFloat(isData[i]?.subtotal_volume_per_item)
            
            newDetail[i]["subtotal_weight"] = parseFloat(isData[i]?.subtotal_weight)
            newDetail[i]["subtotal_case_weight"] = parseFloat(isData[i]?.subtotal_case_weight)
            
          if (isData[i]?.is_use_pallet === "Y") {
            let ceil = Math.ceil(
              isData[i]?.no_of_item / isData[i]?.no_of_item_per_pallet
            );
            newDetail[index]["no_of_item"] = Number(
              ceil * isData[i]?.no_of_item_per_pallet
            );
            setIsData(newDetail);
          }
          setIsData(newDetail)
          setAdd(true);
          setIsOpen(false);
          setChangeItem(false);
        }
      }
    } else {
      let errors = {};
      let sub = isData[i];
      for (const key in sub) {
        const option = validOrder(key, sub[key], t);
        const currentError = option;
        errors = { ...currentError, ...errors };
      }
      setError(errors);
      if (validateSubmit(errors)) {
        let newDetail = [...isData];
        newDetail[i]["weight"] = parseFloat(isData[i]?.weight)
        newDetail[i]["width"] = parseFloat(isData[i]?.width)
        newDetail[i]["height"] = parseFloat(isData[i]?.height)
        newDetail[i]["length"] = parseFloat(isData[i]?.length)
        newDetail[i]["volume"] = parseFloat(isData[i]?.volume)
        newDetail[i]["subtotal_volume_per_item"] = parseFloat(isData[i]?.subtotal_volume_per_item)
        newDetail[i]["subtotal_weight"] = parseFloat(isData[i]?.subtotal_weight)
            newDetail[i]["subtotal_case_weight"] = parseFloat(isData[i]?.subtotal_case_weight)
            
        
        if (isData[i]?.is_use_pallet === "Y") {
          let ceil = Math.ceil(
            isData[i]?.no_of_item / isData[i]?.no_of_item_per_pallet
          );
          newDetail[index]["no_of_item"] = Number(
            ceil * isData[i]?.no_of_item_per_pallet
          );
          setIsData(newDetail);
        }
      setIsData(newDetail)
        setAdd(true);
        setIsOpen(false);
        setChangeItem(false);
      }
    }
  };

  const addRowsAdr = (e) => {
    setAddAdr(false);
    setChangeAddress(true);
    setIsDataAdr([
      ...isData,
      {
        country_id: "",
        island_id: 0,
        province_id: "",
        district_id: "",
        sub_district_id: "",
        urban_village_id: "",
        address: "",
        neighbourhood: "",
        hamlet: "",
        postal_code: "",
        longitude: "",
        latitude: "",
      },
    ]);
  };

  const addRows = (e) => {
    setAdd(false);
    setChangeItem(true);
    setIsData([
      ...isData,
      {
        item_brand: "",
        // product_id: 3,
        item_name: "",
        item_category: "",
        no_of_item: "",
        is_use_pallet: "Y",
        pallet_id: "",
        no_of_item_per_pallet: "",
        width: "",
        height: "",
        length: "",
        weight: "",
        volume: "",
        subtotal_volume_per_item: "",
        subtotal_weight: "",
        subtotal_case_weight: 0,
      },
    ]);
  };

  const removeAddress = (i) => {
    setAddAdr(true);
  };

  const addAddress = (i) => {
    let errors = {};
    let sub = isData[i];
    for (const key in sub) {
      const option = validCustomer(key, sub[key], t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      setAdd(true);
      setIsOpen(false);
      setChangeAddress(false);
    }
  };

  const setBlurNoItem = (index, e) => {
    const newDetail = [...isData];
    // newDetail[index][e] = isDat;
    let num = newDetail[index][e] ? newDetail[index][e] : 0;
    if (isData[index]?.is_use_pallet === "Y" && newDetail[index][e]) {
      let ceil = Math.ceil(isData[index]?.no_of_item / num);

      newDetail[index]["no_of_item"] =
        ceil === Infinity && !(ceil * num) ? 0 : Number(ceil * num);
      setIsData(newDetail);
    }
  };

  const handleChange = (value, name) => {
    setIsMax(false)
    setErrAddress("")
    onChanged(dispatch, true);
    const isChange = true
    if (name === "customer_id") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });

      let eror = validOrder(name, value, t);
      setError({ ...error, ...eror });
      getCustomerDetail(value);
    } else if (name === "skill_set" || name === "temperature_category") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });

      let eror = validOrder(name, value, t);
      setError({ ...error, ...eror });
      // getCustomerDetail(value);
    } else if (name === "order_priority") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: Number(value),
        };
      });       let eror = validOrder(name, value, t);
      setError({ ...error, ...eror });
    } else if (name === "delivery_type_id") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["total_price"]: DTList[DTList.findIndex((el)=>el.delivery_type_id===value)]?.total_price
        };
      });

      let eror = validOrder(name, value, t);
      setError({ ...error, ...eror });
    } else if (name === "custCat") {
      if (value.target.value === "existing") {
        setCustCat(value.target.value);
        setForm((prevsValue) => {
          return {
            ...prevsValue,
            ["country"]: "",
            ["island"]: 0,
            ["province"]: "",
            ["district"]: "",
            ["sub_district"]: "",
            ["urban_village"]: "",
            ["postal_code"]: "",
            ["hamlet"]: "",
            ["neighbourhood"]: "",
            ["address"]: "",
            ["longitude"]: "",
            ["latitude"]: "",
            ["first_name"]: "",
            ["last_name"]: "",
            ["phone"]: "",
            ["fax"]: "",
            ["email"]: "",
          };
        });
      } else {
        let eror = validOrder(name, value.target.value, t);
        setError({ ...error, ...eror });
        setCustCat(value.target.value);
        // setDetail([]);
        setAddAdr(true);
        setForm((prevsValue) => {
          return {
            ...prevsValue,
            ["customer_id"]: "",
            ["country"]: "",
            ["island"]: 0,
            ["province"]: "",
            ["district"]: "",
            ["sub_district"]: "",
            ["urban_village"]: "",
            ["postal_code"]: "",
            ["hamlet"]: "",
            ["neighbourhood"]: "",
            ["address"]: "",
            ["longitude"]: "",
            ["latitude"]: "",
            ["address_id"]:null
          };
        });
      }
    } else if (name === "country") {
      setIsland([]);
      setProvince([]);
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      // getListIsland(value);
      getListProvince(value, 1, 10, "", isChange);

      setSearchValue("")
      setFilter("")
      let eror = validCustomer("country_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["island"]: "",
          ["province"]: "",
          ["district"]: "",
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["address"]: "",
          ["postal_code"]: "",
        };
      });
      setC(country[country.findIndex((el) => el.props.value === value)]?.props?.children);
      let lnglat = country[country.findIndex((el) => el.props.value === value)]?.props?.children
      geocode(lnglat,true);
    } else if (name === "island") {
      // setProvince([]);
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      // getListProvince(value);
      let eror = validCustomer("island_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["province"]: "",
          ["district"]: "",
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["address"]: "",
          // ["postal_code"]: "",
        };
      });
      setI([
        ...longlat,
        island[island.findIndex((el) => el.value === value)].label,
      ]);
    } else if (name === "province") {
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListDistrict(form.country, value, 1, 10, "", isChange);
      setSearchValue("")
      setFilter("")
      let eror = validCustomer("province_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["district"]: "",
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["address"]: "",
          ["postal_code"]: "",
        };
      });
      setP(province[province.findIndex((el) => el.props.value === value)]?.props?.children);
      let lnglat =
        c +
        "," +
        province[province.findIndex((el) => el.props.value === value)]?.props?.children;
      geocode(lnglat, true);
    } else if (name === "district") {
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListSubdistrict(form.country, value, 1, 10, "", isChange);
      setSearchValue("")
      setFilter("")
      let eror = validCustomer("district_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["address"]: "",
          ["postal_code"]: "",
        };
      });
      setD(district[district.findIndex((el) => el.props.value === value)]?.props?.children);
      let lnglat =
        c +
        "," +
        p +
        "," +
        district[district.findIndex((el) => el.props.value === value)]?.props?.children;
      geocode(lnglat,true);
    } else if (name === "sub_district") {
      setUrbanvillage([]);
      setPostalcode([]);
      getListUrbanvillage(form.country, value, 1, 10, "", isChange);
      setSearchValue("")
      setFilter("")
      let eror = validCustomer("sub_district_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["urban_village"]: "",
          // ["address"]: "",
          // ["postal_code"]: "",
        };
      });
      setS(subdistrict[subdistrict.findIndex((el) => el.props.value === value)]?.props?.children);
      let lnglat =
        c +
        "," +
        p +
        "," +
        d +
        "," +
        subdistrict[subdistrict.findIndex((el) => el.props.value === value)]?.props?.children;
      // geocode(lnglat);
    } else if (name === "urban_village") {
      setPostalcode([]);
      getListPostalCode(form.country, value);
      setSearchValue("")
      setFilter("")
      let eror = validCustomer("urban_village_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          // ["address"]: "",
          // ["postal_code"]: "",
        };
      });
      setU(urbanvillage[urbanvillage.findIndex((el) => el.props.value === value)]?.props?.children);
      let lnglat =
        c +
        "," +
        p +
        "," +
        d +
        "," +
        s +
        "," +
        urbanvillage[urbanvillage.findIndex((el) => el.props.value === value)]?.props?.children;
      // geocode(lnglat);
    } else if (name === "postal_code") {
      // getListSubdistrict(form.country, value);
      let eror = validCustomer("postal_code", value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: Number(value.target.value),
        };
      });
      // if (addressFormat < 0) {
      //   let lnglat =
      //     c +
      //     "," +
      //     p +
      //     "," +
      //     d +
      //     "," +
      //     s +
      //     "," +
      //     u +
      //     "," +
      //     i +
      //     " " +
      //     isData[index]?.address;
      //   geocode(lnglat, index);
      // }
    } else if (name === "address") {
      // if(addressFormat >=1){
      let eror = validCustomer(name, value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
        };
      });

      // if (addressFormat < 0) {
      //   let lnglat =
      //     c + "," + p + "," + d + "," + s + "," + u + "," + value.target.value;
      //   geocode(lnglat, index);
      // }
    } else if (
      name === "first_name" ||
      name === "last_name" ||
      name === "phone" ||
      name === "email" ||
      name === "fax" ||
      name === "hamlet" ||
      name === "neighbourhood" ||
      name === "longitude" ||
      name === "latitude"
    ) {
      let eror = validCustomer(name, value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
        };
      });
    } else {
      setChange(true);
      let eror = validOrder(name, value.target.value, t);


      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
        };
      });
    }
  };

  const handleChangeItem = (i, index, e, tes) => {
    onChanged(dispatch, true);
    const newDetail = [...isData];
    setChange(true);
    setChangeItem(true);
    if (e === "pallet_id") {
      let eror = validOrder(e, i, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = i;
      if (isData[index]?.is_use_pallet === "Y") {
        let weight = pallet[pallet?.findIndex((ele) => ele.value === i)].weight;
        let width = pallet[pallet?.findIndex((ele) => ele.value === i)].width;
        let length = pallet[pallet?.findIndex((ele) => ele.value === i)].length;
        let height = pallet[pallet?.findIndex((ele) => ele.value === i)].height;
        setWeightPallet(weight);
        setWidthPallet(width);
        setHeightPallet(height);
        setLengthPallet(length);
        newDetail[index]["subtotal_weight"] = parseFloat(
          weight + isData[index]?.weight
        );
      }
    } else if (e === "volume") {
      let eror = validOrder(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = !i.target.value ? 0 :i.target.value;
      if (isData[index]?.is_use_pallet === "Y") {
        let totalVPallet = heightPallet * widthPallet * lengthPallet;
        let ceil = Math.ceil(
          Number(isData[index]?.no_of_item) /
          Number(isData[index]?.no_of_item_per_pallet)
        );
        newDetail[index]["subtotal_volume_per_item"] =
          parseFloat(totalVPallet * ceil + parseFloat(i.target.value).toFixed(2));
      } else {
        newDetail[index]["subtotal_volume_per_item"] = parseFloat(i.target.value).toFixed(2);
      }
    } else if (e === "subtotal_case_weight") {
      let eror = validOrder(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = !i.target.value ? 0 :i.target.value;
      newDetail[index]["subtotal_weight"] =
        parseFloat(parseFloat(i.target.value) + Number(isData[index]?.weight)).toFixed(2);
      if (isData[index]?.is_use_pallet === "Y") {
        let weight =
          pallet[
            pallet?.findIndex((ele) => ele.value === newDetail[index].pallet_id)
          ].weight;
        newDetail[index]["subtotal_weight"] = parseFloat(Number(
          weight + Number(isData[index]?.weight) + parseFloat(i.target.value)
        )).toFixed(2);
      }
    } else if (e === "is_use_pallet") {
      newDetail[index][e] = i.target.value;
      if (i.target.value === "N") {
        delete newDetail[index].pallet_id;
        delete newDetail[index].no_of_item_per_pallet;
      } else {
        newDetail[index]["pallet_id"] = 0;
        newDetail[index]["no_of_item_per_pallet"] = 0;
      }
    } else if (
      e === "item_brand" ||
      e === "item_name" ||
      e === "item_category"
    ) {
      let eror = validOrder(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = i.target.value;
    } else if (e === "weight") {
      let eror = validOrder(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = !i.target.value ? 0 :i.target.value;
      newDetail[index]["subtotal_weight"] = parseFloat(i.target.value);
      if (isData[index]?.is_use_pallet === "Y") {
        let weight =
          pallet[
            pallet?.findIndex((ele) => ele.value === newDetail[index].pallet_id)
          ].weight;
        newDetail[index]["subtotal_weight"] = parseFloat(Number(
          weight + parseFloat(i.target.value)
        ));
      }
    } else if (e === "no_of_item") {
      let eror = validOrder(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = Number(i.target.value);
      if (isData[index]?.is_use_pallet === "Y") {
        newDetail[index]["no_of_item_per_pallet"] = "";
      }
    } else if (e === "no_of_item_per_pallet") {
      let eror = validOrder(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = Number(i.target.value)
      // let num = i.target.value ? i.target.value : 0;

      // if (isData[index]?.is_use_pallet === "Y") {
      //   let ceil = Math.ceil(isData[index]?.no_of_item / num);

      //   console.log(
      //     "isnan cek",
      //     ceil === Infinity && !(ceil * num) ? 0 : Number(ceil * num)
      //   );
      //   newDetail[index]["no_of_item"] =
      //     ceil === Infinity && !(ceil * num) ? 0 : Number(ceil * num);
      //   // setIsData(newDetail);
      // }
      // newDetail[index]["no_of_item"]=i.target.value
    } else if (e === "width") {
      let eror = validOrder(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = !i.target.value ? 0 :i.target.value;
    } else if (e === "height") {
      let eror = validOrder(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] =!i.target.value ? 0 :i.target.value;;
    } else if (e === "length") {
      let eror = validOrder(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = !i.target.value ? 0 :i.target.value;
    } else {
      let eror = validOrder(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = Number(i.target.value);
    }
    setIsData(newDetail);
  };

  const onBlurFloat = () => {

  }

  const getSkillset = (value) => {
    const val = value?.data.map((el) => el.value.split("-")[0].split(" ")[0]);
    let vals =
      // value.data[0]?.value === "All"
      //   ? ["Sunday", "Monday", "Tuesday", "Wednesday", "Friday", "Saturday"]
      //   :
      value?.data.map((el) => el.id);
    setSkillset((prevsValue) => {
      return {
        ...prevsValue,
        ["data"]: vals,
      };
    });
  };

  const getTemp = (value) => {
    const val = value?.data.map((el) => el.value.split("-")[0].split(" ")[0]);
    let vals =
      // value.data[0]?.value === "All"
      //   ? ["Sunday", "Monday", "Tuesday", "Wednesday", "Friday", "Saturday"]
      //   :
      value?.data.map((el) => el.id);
    setTemp((prevsValue) => {
      return {
        ...prevsValue,
        ["data"]: vals,
      };
    });
  };

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_ORDER_URL;
    // const api = `http://app.sbp:9005/manager/v1/grolog`;
    // if(validateExpired(token,dispatch,refresh_token)) {
    //   token = await doRefreshToken(token,dispatch);
    // }

    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };
  
  const doPostDT = async (endpoint, tkn, data, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_URL;
    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };

  // const getTotal = (name)=>{
  let subWeight = isData?.map((el) => el.subtotal_weight);
  let subVol = isData?.map((el) => el.volume);

  const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "PUT";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  //   let custAdr=[...detail?.customer_address,
  //     {
  //       country_id: form?.country ? form.country : "",
  // island_id: form?.island ? form.island : 0,
  // province_id: form?.province ? form.province : "",
  // district_id: form?.district ? form.district : "",
  // sub_district_id: form?.sub_district ? form.sub_district : "",
  // urban_village_id: form?.urban_village ? form.urban_village : "",
  // address: form?.address ? form.address : "",
  // neighbourhood: form?.neighbourhood ? form.neighbourhood : "",
  // hamlet: form?.hamlet ? form.hamlet : "",
  // postal_code: form?.postal_code ? form.postal_code : "",
  // longitude: form?.longitude ? form.longitude : "",
  // latitude: form?.latitude ? form.latitude : "",
  //     }
  //   ]

  const getDistance = () => {
    var distanceService = new window.google.maps.DistanceMatrixService();

    // Define the origin and destination coordinates
    var origin = new window.google.maps.LatLng(
      Number(details?.depot_profile?.depot_latitude),
      Number(details?.depot_profile?.depot_longitude)
    );
    var destination = new window.google.maps.LatLng(
      Number(form?.latitude),
      Number(form?.longitude)
    );

    // Create a request object
    var request = {
      origins: [origin],
      destinations: [destination],
      travelMode: "DRIVING",
      unitSystem: window.google.maps.UnitSystem.METRIC,
    };

    // Call the getDistanceMatrix method of the DistanceMatrixService to get the distance
    distanceService.getDistanceMatrix(request, function (response, status) {
      if (status == "OK") {
        setIsMax(response?.rows[0]?.elements[0]?.distance?.value / 1000 > radius);

      } else {
      }
    });
  };

  const onSubmit = async () => {
    let errors = {};
    let datacheck = {
      delivery_type_id: form.delivery_type_id ? form.delivery_type_id : "",
      delivery_notes: form.delivery_notes ? form.delivery_notes : "",
      order_priority: form.order_priority ? form.order_priority : "",
    };
    for (const key in datacheck) {
      const option = validOrder(key, datacheck[key], t);
      // let option = validUserProfile(key, value[key], this.props.t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      let sub = {
        ...form,
        recipient_name: form?.recipient_name ? form?.recipient_name : "",
        recipient_phone: form?.recipient_phone ? "+62-" + form?.recipient_phone : "",
        customer_id: form?.customer_id ? form?.customer_id : 0,
        depot_id: location.state,
        order_no: form?.order_number ? form?.order_number : "",
        company_profile_id: 1,
        phone: form?.phone ? "+62-" + form?.phone : "",
        address_id:
          form?.address_id === "N"
            ? 0
            : form?.address_id !== "N"
              ? form?.address_id
              : detail?.customer_address[0]?.address_id
                ? detail?.customer_address[0]?.address_id
                : 0,
        country_id: form?.country ? form?.country : 0,
        island_id: form?.island ? form?.island : 0,
        province_id: form?.province ? form.province : 0,
        district_id: form?.district ? form.district : 0,
        sub_district_id: form?.sub_district ? form.sub_district : 0,
        urban_village_id: form?.urban_village ? form.urban_village : 0,
        total_weight: subWeight
          ? subWeight?.reduce((acc, curr) => acc + curr)
          : 0,
        total_volume: subVol ? subVol?.reduce((acc, curr) => acc + curr) : 0,
        total_price: form?.total_price ? form?.total_price : 0,
        skill_set: {
          skill_set_id: [Number(form?.skill_set)],
        },
        temperature_category: {
          temperature_category_id: [Number(form?.temperature_category)],
        },
        item: isData,
      };
      if (custCat === "existing") {
        delete sub.first_name;
        delete sub.last_name;
        delete sub.phone;
        delete sub.fax;
        delete sub.email;
      }
      if (custCat === "existing" && form.address_id !== "N") {
        delete sub.first_name;
        delete sub.last_name;
        delete sub.phone;
        delete sub.fax;
        delete sub.email;
        delete sub.country;
        delete sub.island;
        delete sub.hamlet;
        delete sub.district;
        delete sub.longitude;
        delete sub.latitude;
        delete sub.neighbourhood;
        delete sub.postal_code;
        delete sub.province;
        delete sub.sub_district;
        delete sub.urban_village;
        delete sub.address;
      }

      let updateAddress = {
        ...detail,
        customer_address: [
          ...addressSubmit,
          {
            recipient_name: form?.recipient_name ? form?.recipient_name : "",
            recipient_phone: form?.recipient_phone ? "+62-" + form?.recipient_phone : "",
            country_id: form?.country ? form.country : "",
            island_id: form?.island ? form.island : 0,
            province_id: form?.province ? form.province : "",
            district_id: form?.district ? form.district : "",
            sub_district_id: form?.sub_district ? form.sub_district : "",
            urban_village_id: form?.urban_village ? form.urban_village : "",
            address: form?.address ? form.address : "",
            neighbourhood: form?.neighbourhood ? form.neighbourhood : "",
            hamlet: form?.hamlet ? form.hamlet : "",
            postal_code: form?.postal_code ? form.postal_code : "",
            longitude: form?.longitude ? form.longitude : "",
            latitude: form?.latitude ? form.latitude : "",
          },
        ],
      };
      try {
        let tkn = token;

        let param =
          "CLIENT_ID=1231278asdbaiaerrs&RESOURCE_USER_ID=13&GROLOG_ACCOUNT_ID=1";
        let res = await doPost(`/order?${param}`, token, sub);
        setSuccessModalOpen(true);
      } catch (err) {
        if (
          err.response.data.payload.message ===
          "Data with this Additional Name is already used by other, cant process this action"
        ) {
          // setErr(err.response.data.payload.message)
        } else {
          message.error(_.startCase(err.response.data.payload.message));
        }
      }
      if (custCat === "existing" && form?.address_id === "N") {
        try {
          let tkn = token;
          let param =
            "CLIENT_ID=1231278asdbaiaerrs&RESOURCE_USER_ID=13&GROLOG_ACCOUNT_ID=1";
          let res = await doPut(
            `/customer/${form?.customer_id}?${param}`,
            tkn,
            updateAddress
          );
          // setSuccessModalOpen(true);
          message.success(_.startCase("Success Updated Customer Address"));
        } catch (err) {
          if (
            err.response.data.payload.message ===
            "Data with this Additional Name is already used by other, cant process this action"
          ) {
            // setErr(err.response.data.payload.message)
          } else {
            message.error(_.startCase(err.response.data.payload.message));
          }
        }
      }
    }
  };

  const handleNext = () => {
    let errors = {};
    let datacheck = {
      skill_set: form.skill_set ? form.skill_set : "",
      temperature_category: form.temperature_category
        ? form.temperature_category
        : "",
    };
    for (const key in datacheck) {
      const option = validOrder(key, datacheck[key], t);
      // let option = validUserProfile(key, value[key], this.props.t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      setPage(2);
    }
  };

  const handleNext2 = () => {
    getDistance();
    getDelivery(1, 10, "");

    let errors = {};
    let datacheck = {
      customer_id: form.customer_id ? form.customer_id : "",
    };
    let sub = {
      first_name: form?.first_name ? form.first_name : "",
      last_name: form?.last_name ? form.last_name : "",
      phone: form?.phone ? form.phone : "",
      email: form?.email ? form.email : "",
      marital_status: form?.marital_status ? form.marital_status : "",
      country_id: form?.country ? form.country : "",
      island_id: form?.island ? form.island : 0,
      province_id: form?.province ? form.province : "",
      district_id: form?.district ? form.district : "",
      sub_district_id: form?.sub_district ? form.sub_district : "",
      urban_village_id: form?.urban_village ? form.urban_village : "",
      address: form?.address ? form.address : "",
      neighbourhood: form?.neighbourhood ? form.neighbourhood : "",
      hamlet: form?.hamlet ? form.hamlet : "",
      postal_code: form?.postal_code ? form.postal_code : "",
      longitude: form?.longitude ? form.longitude : "",
      latitude: form?.latitude ? form.latitude : "",
    };
    let news = {
      country_id: form?.country ? form.country : "",
      island_id: form?.island ? form.island : 0,
      province_id: form?.province ? form.province : "",
      district_id: form?.district ? form.district : "",
      sub_district_id: form?.sub_district ? form.sub_district : "",
      urban_village_id: form?.urban_village ? form.urban_village : "",
      address: form?.address ? form.address : "",
      neighbourhood: form?.neighbourhood ? form.neighbourhood : "",
      hamlet: form?.hamlet ? form.hamlet : "",
      postal_code: form?.postal_code ? form.postal_code : "",
      longitude: form?.longitude ? form.longitude : "",
      latitude: form?.latitude ? form.latitude : "",
    };
    if (custCat === "existing") {
      for (const key in datacheck) {
        const option = validOrder(key, datacheck[key], t);
        // let option = validUserProfile(key, value[key], this.props.t);
        const currentError = option;
        errors = { ...currentError, ...errors };
      }
      if (form?.address_id === "N") {
        for (const key in news) {
          const option = validCustomer(key, news[key], t);
          // let option = validUserProfile(key, value[key], this.props.t);
          const currentError = option;
          errors = { ...currentError, ...errors };
        }
      }
      setError(errors);
      if (validateSubmit(errors) && !isMax) {
        setPage(3);
      }
    } else {
      for (const key in sub) {
        const option = validCustomer(key, sub[key], t);
        // let option = validUserProfile(key, value[key], this.props.t);
        const currentError = option;
        errors = { ...currentError, ...errors };
      }
      setError(errors);
      if (validateSubmit(errors) && !isMax) {
        setPage(3);
      }
    }
  };

  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // Allow only number input
    if (!REGEX_CONSTANT.JUST_NUMBER.test(keyValue)) {
      event.preventDefault();
    }
  };

  const page1 = () => {
    return (
      <>
        <div className="flex">
          <div>
            <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
              {t("Order Information")}
            </h3>
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Order Number") + " (Optional)"}
                  </label>
                  <Input
                    status={error?.order_number ? "error" : ""}
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Order Number"
                    value={form?.order_number}
                    onChange={(value) => handleChange(value, "order_number")}
                  />
                  <div className="text-red-100">{error?.order_number}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Skillset")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.skill_set ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.skill_set}
                    onChange={(value) => handleChange(value, "skill_set")}
                    onPopupScroll={(e) => onScrollSkillset(e)}
                    loading={loading}
                    // options={Skillset}
                    placeholder="Select Skillset"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeSkillset(value),
                        searchValue
                      )
                    }
              >
              {!loading ? skillset : [...skillset]}
                </Select>
                  {/* <MSSSkillset
                    token={token}
                    param={param}
                    getValue={(value) => getSkillset(value)}
                    level={1}
                    // isEdit={true}
                    isSelectAll={skillset.flagCheckAll}
                    currentValue={
                      skillset?.data?.length !== 0 &&
                      skillset?.data !== undefined
                        ? skillset?.data.map((el) => el.value)
                        : undefined
                    }
                    // error={this.state.error}
                    errorNamespace={"skill_set"}
                  /> */}
                  <div className="text-red-100">{error?.skill_set}</div>
                </div>
              </div>
              <div className="gap-[40px] mb-[24px] ml-10">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium mb-6">
                    {t("Temperature Category")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.temperature_category ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.temperature_category}
                    onChange={(value) =>
                      handleChange(value, "temperature_category")
                    }
                    onPopupScroll={(e) => onScrollTemp(e)}
                    loading={loading}
                    // options={Temp}
                    placeholder="Select Temp"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeTemp(value),
                        searchValue
                      )
                    }
              >
              {!loading ? temp : [...temp]}
                </Select>
                  {/* <MSSTemperatureCategory
                    token={token}
                    param={param}
                    getValue={(value) => getTemp(value)}
                    level={1}
                    // isEdit={true}
                    isSelectAll={temp.flagCheckAll}
                    currentValue={
                      temp?.data?.length !== 0 && temp?.data !== undefined
                        ? temp?.data.map((el) => el.value)
                        : undefined
                    }
                    // error={this.state.error}
                    errorNamespace={"temperature_category"}
                  /> */}
                  {/* <Input
                    status={error?.first_name ? "error" : ""}
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type First Name"
                    onChange={(value) => handleChange(value, "first_name")}
                  /> */}
                  <div className="text-red-100">
                    {error?.temperature_category}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Order Item */}
        {isData.map((el, i) => {
          return (
            <div id={i}>
              <Accordion
                onClick={() => clickCard(i, isOpen)}
                index={i}
                i={index}
                isOpen={isOpen}
                address={
                  el.item_name
                    ? el.item_brand +
                    " - " +
                    el.item_name +
                    " - " +
                    el.no_of_item +
                    " Pcs"
                    : "Item " + (i + 1)
                }
                body={
                  <>
                    {isOpen === true && i === index ? (
                      <>
                        <div className="flex ml-10">
                          <div>
                            <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
                              {t("Item Detail")}
                            </h3>
                            <div className="flex">
                              {/* line one */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-base font-medium">
                                    {t("Item Brand")}
                                  </label>
                                  <Input
                                    status={error?.item_brand ? "error" : ""}
                                    className="mt-[8px] h-[47px] w-[500px]"
                                    placeholder="Type Item Brand"
                                    value={el?.item_brand}
                                    onChange={(value) =>
                                      handleChangeItem(value, i, "item_brand")
                                    }
                                  />
                                  <div className="text-red-100">
                                    {error?.item_brand}
                                  </div>
                                </div>
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-base font-medium">
                                    {t("Item Name")}
                                  </label>
                                  <Input
                                    status={error?.item_name ? "error" : ""}
                                    className="mt-[8px] h-[47px] w-[500px]"
                                    placeholder="Type Item Name"
                                    value={el?.item_name}
                                    onChange={(value) =>
                                      handleChangeItem(value, i, "item_name")
                                    }
                                  />
                                  <div className="text-red-100">
                                    {error?.item_name}
                                  </div>
                                </div>
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-base font-medium">
                                    {t("Item Category")}
                                  </label>
                                  <Input
                                    status={error?.item_category ? "error" : ""}
                                    className="mt-[8px] h-[47px] w-[500px]"
                                    placeholder="Type Item Category"
                                    value={el?.item_category}
                                    onChange={(value) =>
                                      handleChangeItem(
                                        value,
                                        i,
                                        "item_category"
                                      )
                                    }
                                  />
                                  <div className="text-red-100">
                                    {error?.item_category}
                                  </div>
                                </div>
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-base font-medium">
                                    {t("Number of item")}
                                  </label>
                                  <Space.Compact>
                                    <Input
                                      style={{ width: "480px", height: "47px" }}
                                      status={error?.no_of_item ? "error" : ""}
                                      placeholder="Type no_of_item"
                                      value={el?.no_of_item}
                                      onChange={(value) =>
                                        handleChangeItem(value, i, "no_of_item")
                                      }
                                    />
                                    <Input
                                      style={{ width: "15%" }}
                                      defaultValue="PCS"
                                      disabled
                                    />
                                  </Space.Compact>
                                  <div className="text-red-100">
                                    {error?.no_of_item}
                                  </div>
                                </div>
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-base font-medium">
                                    {t("Pallet")}
                                  </label>
                                  <div className={style.radio}>
                                    <Radio.Group
                                      onChange={(value) =>
                                        handleChangeItem(
                                          value,
                                          i,
                                          "is_use_pallet"
                                        )
                                      }
                                      value={el.is_use_pallet}
                                      // defaultValue="view"
                                      className="flex"
                                    >
                                      <Radio value="Y">Yes</Radio>
                                      <Radio value="N">No</Radio>
                                    </Radio.Group>
                                  </div>
                                </div>
                                {el.is_use_pallet === "Y" ? (
                                  <>
                                    <div className="w-[500px] mb-[24px]">
                                      <label className="font-roboto text-base font-medium">
                                        {t("Pallet")}
                                      </label>
                                      <Select
                                        className="w-[500px]"
                                        status={error?.pallet_id ? "error" : ""}
                                        dropdownStyle={{
                                          backgroundColor: "white",
                                        }}
                                        size="large"
                                        value={el.pallet_id}
                                        onChange={(value) =>
                                          handleChangeItem(
                                            value,
                                            i,
                                            "pallet_id"
                                          )
                                        }
                                        onPopupScroll={(e) => onScrollPallet(e)}
                    loading={loading}
                    // options={Pallet}
                    placeholder="Select Pallet"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangePallet(value),
                        searchValue
                      )
                    }
              >
              {!loading ? pallet2: [...pallet2]}
                </Select>
                                      <div className="text-red-100">
                                        {error?.pallet_id}
                                      </div>
                                    </div>
                                    <div className="w-[500px] mb-[24px]">
                                      <label className="font-roboto text-base font-medium">
                                        {t("Number of Item per Pallet")}
                                      </label>
                                      <Input
                                        status={
                                          error?.no_of_item_per_pallet
                                            ? "error"
                                            : ""
                                        }
                                        value={el?.no_of_item_per_pallet}
                                        className="mt-[8px] h-[47px] w-[500px]"
                                        placeholder="Type Number of Item per Pallet"
                                        showCount={false}
                                        onKeyPress={(evt) =>
                                          handleKeyPress(evt)
                                        }
                                        onBlur={(value) =>
                                          setBlurNoItem(
                                            i,
                                            "no_of_item_per_pallet"
                                          )
                                        }
                                        onChange={(value) =>
                                          handleChangeItem(
                                            value,
                                            i,
                                            "no_of_item_per_pallet"
                                          )
                                        }
                                      />
                                      <div className="text-red-100">
                                        {error?.no_of_item_per_pallet}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* line two */}
                          <div className="ml-10">
                            <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
                              {t("Detail Specification")}
                            </h3>
                            <div className="flex">
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[500px] mb-[24px] flex">
                                  <div>
                                    <label className="font-roboto text-base font-medium">
                                      {t("Width")}
                                    </label>
                                    <Space.Compact>
                                      <Input
                                        style={{
                                          width: "200px",
                                          height: "47px",
                                          marginTop: "8px",
                                        }}
                                        value={el?.width}
                                        status={
                                          error?.width ||
                                            (el?.is_use_pallet === "Y" &&
                                              el?.pallet_id &&
                                              el?.width >= widthPallet)
                                            ? "error"
                                            : ""
                                        }
                                        placeholder="Type width"
                                        onChange={(value) =>
                                          handleChangeItem(value, i, "width")
                                        }
                                      />
                                      <Input
                                        style={{
                                          width: "15%",
                                          marginTop: "8px",
                                        }}
                                        defaultValue="mm"
                                        disabled
                                      />
                                    </Space.Compact>
                                    <div className="text-red-100">
                                      {el?.is_use_pallet === "Y" &&
                                        el?.pallet_id &&
                                        el?.width >= widthPallet
                                        ? `Max ${widthPallet} m`
                                        : error?.width}
                                    </div>
                                  </div>
                                  <div>
                                    <label className="font-roboto text-base font-medium">
                                      {t("Height")}
                                    </label>
                                    <Space.Compact>
                                      <Input
                                        style={{
                                          width: "200px",
                                          height: "47px",
                                          marginTop: "8px",
                                        }}
                                        value={el?.height}
                                        status={error?.height ? "error" : ""}
                                        placeholder="Type height"
                                        onChange={(value) =>
                                          handleChangeItem(value, i, "height")
                                        }
                                      />
                                      <Input
                                        style={{
                                          width: "15%",
                                          marginTop: "8px",
                                        }}
                                        defaultValue="mm"
                                        disabled
                                      />
                                    </Space.Compact>
                                    <div className="text-red-100">
                                      {error?.height}
                                    </div>
                                  </div>
                                </div>
                                <div className="w-[500px] mb-[24px] flex">
                                  <div>
                                    <label className="font-roboto text-base font-medium">
                                      {t("Length")}
                                    </label>
                                    <Space.Compact>
                                      <Input
                                        style={{
                                          width: "200px",
                                          height: "47px",
                                          marginTop: "8px",
                                        }}
                                        value={el?.length}
                                        status={
                                          error?.length ||
                                            (el?.is_use_pallet === "Y" &&
                                              el?.pallet_id &&
                                              el?.length >= lengthPallet)
                                            ? "error"
                                            : ""
                                        }
                                        placeholder="Type length"
                                        onChange={(value) =>
                                          handleChangeItem(value, i, "length")
                                        }
                                      />
                                      <Input
                                        style={{
                                          width: "15%",
                                          marginTop: "8px",
                                        }}
                                        defaultValue="mm"
                                        disabled
                                      />
                                    </Space.Compact>
                                    <div className="text-red-100">
                                      {el?.is_use_pallet === "Y" &&
                                        el?.pallet_id &&
                                        el?.length >= lengthPallet
                                        ? `Max ${lengthPallet} m`
                                        : error?.length}
                                    </div>
                                  </div>
                                  <div>
                                    <label className="font-roboto text-base font-medium">
                                      {t("Weight")}
                                    </label>
                                    <Space.Compact>
                                      <Input
                                        style={{
                                          width: "200px",
                                          height: "47px",
                                          marginTop: "8px",
                                        }}
                                        value={el?.weight}
                                        status={error?.weight ? "error" : ""}
                                        placeholder="Type weight"
                                        onChange={(value) =>
                                          handleChangeItem(value, i, "weight")
                                        }
                                      />
                                      <Input
                                        style={{
                                          width: "15%",
                                          marginTop: "8px",
                                        }}
                                        defaultValue="Kg"
                                        disabled
                                      />
                                    </Space.Compact>
                                    <div className="text-red-100">
                                      {error?.weight}
                                    </div>
                                  </div>
                                </div>
                                <div className="w-[250px] mb-[24px]">
                                  <div>
                                    <label className="font-roboto text-base font-medium w-[500px]">
                                      {t("Volume")}
                                    </label>
                                    <Space.Compact>
                                      <Input
                                        style={{
                                          width: "200px",
                                          height: "47px",
                                          marginTop: "8px",
                                        }}
                                        value={el?.volume}
                                        status={error?.volume ? "error" : ""}
                                        placeholder="Type volume"
                                        onChange={(value) =>
                                          handleChangeItem(value, i, "volume")
                                        }
                                      />
                                      <Input
                                        style={{
                                          width: "15%",
                                          marginTop: "8px",
                                        }}
                                        value="m2"
                                        disabled
                                      />
                                    </Space.Compact>
                                    <div className="text-red-100">
                                      {error?.volume}
                                    </div>
                                  </div>
                                </div>
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-base font-medium">
                                    {t("Subtotal Volume Per Item")}
                                  </label>
                                  <Space.Compact>
                                    <Input
                                      style={{
                                        width: "480px",
                                        height: "47px",
                                        marginTop: "8px",
                                      }}
                                      status={
                                        error?.subtotal_volume_per_item
                                          ? "error"
                                          : ""
                                      }
                                      disabled
                                      value={el?.subtotal_volume_per_item}
                                      placeholder="Type subtotal_volume_per_item"
                                      onChange={(value) =>
                                        handleChangeItem(
                                          value,
                                          i,
                                          "subtotal_volume_per_item"
                                        )
                                      }
                                    />
                                    <Input
                                      style={{ width: "15%", marginTop: "8px" }}
                                      defaultValue="m2"
                                      disabled
                                    />
                                  </Space.Compact>
                                  <div className="text-red-100">
                                    {error?.subtotal_volume_per_item}
                                  </div>
                                </div>
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-base font-medium">
                                    {t("Subtotal Weight")}
                                  </label>
                                  <Space.Compact>
                                    <Input
                                      style={{
                                        width: "480px",
                                        height: "47px",
                                        marginTop: "8px",
                                      }}
                                      status={
                                        error?.subtotal_weight ? "error" : ""
                                      }
                                      disabled
                                      value={el.subtotal_weight}
                                      placeholder="Type subtotal_weight"
                                      onChange={(value) =>
                                        handleChangeItem(
                                          value,
                                          i,
                                          "subtotal_weight"
                                        )
                                      }
                                    />
                                    <Input
                                      style={{ width: "15%", marginTop: "8px" }}
                                      value="Kg"
                                      disabled
                                    />
                                  </Space.Compact>
                                  <div className="text-red-100">
                                    {error?.subtotal_weight}
                                  </div>
                                </div>
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-base font-medium">
                                    {t("Subtotal Case Weight")}
                                  </label>
                                  <Space.Compact>
                                    <Input
                                      style={{
                                        width: "480px",
                                        height: "47px",
                                        marginTop: "8px",
                                      }}
                                      // type="number"
                                      status={
                                        error?.subtotal_case_weight
                                          ? "error"
                                          : ""
                                      }
                                      value={el?.subtotal_case_weight}
                                      placeholder="Type subtotal_case_weight"
                                      onChange={(value) =>
                                        handleChangeItem(
                                          value,
                                          i,
                                          "subtotal_case_weight"
                                        )
                                      }
                                    />
                                    <Input
                                      style={{ width: "15%", marginTop: "8px" }}
                                      value="Kg"
                                      disabled
                                    />
                                  </Space.Compact>
                                  <div className="text-red-100">
                                    {error?.subtotal_case_weight}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-row-reverse gap-[16px] pb-8 mr-8">
                          <button
                            className="min-w-[87px] h-[44px] gap-3 px-[16px] bg-[#CF0000] text-white-100 text-xl flex items-center justify-evenly rounded-md"
                            onClick={() => addItem(i)}
                          >
                            Add
                          </button>
                          <button
                            onClick={() => removeItem(i)}
                            className="w-[87px] h-[44px] text-[#CF0000] border-[2px] border-[#CF0000] bg-white-100 text-xl flex items-center justify-evenly rounded-md"
                          >
                            Delete
                          </button>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                }
              />
            </div>
          );
        })}
        <div className="p-5" style={{ marginBottom: "20px", width: "100%" }}>
          <div
            className={`h-[40px] ${add ? "bg-red-100" : "bg-gray-100"
              }  opacity-100 rounded-lg cursor-pointer justify-center flex`}
            onClick={add ? () => addRows() : ""}
          >
            <img src={AddIcon} alt="add" />
            <div className="text-white-100 font-semibold text-2xl ml-2 mt-1">
              Add New Item
            </div>
          </div>
        </div>
      </>
    );
  };

  const page2 = () => {
    return (
      <>
        <div className="flex">
          <div>
            <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
              {t("Customer Information")}
            </h3>
            <div className="w-[500px] mb-[24px]">
              <label className="font-roboto text-base font-medium">
                {t("Customer Category")}
              </label>
              <div className={style.radio}>
                <Radio.Group
                  onChange={(value) => handleChange(value, "custCat")}
                  value={custCat}
                  // defaultValue="view"
                  className="flex"
                >
                  <Radio value="existing">Existing</Radio>
                  <Radio value="new">New</Radio>
                </Radio.Group>
              </div>
            </div>
            {custCat === "existing" ? (
              <>
                <div className="flex">
                  {/* line one */}
                  <div className="gap-[40px] mb-[24px]">
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-base font-medium">
                        {t("Customer")}
                      </label>
                      <Select
                        className="w-[500px]"
                        status={error?.customer_id ? "error" : ""}
                        dropdownStyle={{
                          backgroundColor: "white",
                        }}
                        size="large"
                        value={form.customer_id}
                        onChange={(value) => handleChange(value, "customer_id")}
                        onPopupScroll={(e) => onScrollCustomer(e)}
                    loading={loading}
                    // options={Customer}
                    placeholder="Select Customer"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeCustomer(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? customer : [...customer]}
                  </Select>
                      <div className="text-red-100">{error?.customer_id}</div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-base font-medium">
                        {t("Company Profile ID")}
                      </label>
                      <Input
                        // status={error?.last_name ? "error" : ""}
                        className="mt-[8px] h-[47px] w-[500px]"
                        placeholder="Choose Customer ID First"
                        value={detail?.company_profile_id}
                        disabled
                      // onChange={(value) => handleChange(value, "last_name")}
                      />
                      {/* <div className="text-red-100">{error?.last_name}</div> */}
                    </div>
                  </div>

                  <div className="gap-[40px] mb-[24px] ml-10">
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-base font-medium">
                        {t("Customer Email")}
                      </label>
                      <Input
                        // status={error?.last_name ? "error" : ""}
                        className="mt-[8px] h-[47px] w-[500px]"
                        placeholder="Choose Customer ID First"
                        value={form?.email || detail?.email}
                        disabled
                        onChange={(value) => handleChange(value, "email")}
                      />
                      {/* <div className="text-red-100">{error?.last_name}</div> */}
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-base font-medium">
                        {t("Customer Fax")}
                      </label>
                      <Input
                        // status={error?.last_name ? "error" : ""}
                        className="mt-[8px] h-[47px] w-[500px]"
                        placeholder="Choose Customer ID First"
                        value={form?.fax || detail?.fax}
                        disabled
                        onChange={(value) => handleChange(value, "fax")}
                      />
                      {/* <div className="text-red-100">{error?.last_name}</div> */}
                    </div>
                  </div>
                </div>
                <div className={style.radio + " w-[1000px]"}>
                  <Radio.Group
                    onChange={(value) => handleChange(value, "address_id")}
                    value={
                      form?.address_id
                        ? form?.address_id
                        : detail?.customer_address[0]?.address_id
                          ? detail?.customer_address[0]?.address_id
                          : ""
                    }
                  // defaultValue="view"
                  // className="flex"
                  >
                    {detail?.customer_address ? (
                      detail?.customer_address?.map((el, i) => {
                        return (
                          <div id={i}>
                            <Accordion
                              onClick={() => clickCard(i, isOpen)}
                              index={i}
                              i={index}
                              isOpen={isOpen}
                              address={el?.address}
                              radio={<Radio value={el.address_id}></Radio>}
                              body={
                                <>
                                  {isOpen === true && i === index ? (
                                    <>
                                      <ModalMaps
                                        show={isOpenMaps}
                                        address={el.address}
                                        latitude={el.latitude}
                                        longitude={el.longitude}
                                        onClose={() => setIsOpenMaps(false)}
                                      />
                                      <div className="h-full bg-white-100 opacity-100 rounded-b-lg p-4">
                                        <div className="flex">
                                          <div>
                                            <div className="flex">
                                              <div className="gap-[40px] mb-[24px] ml-6">
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t("Customer Country")}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el?.country}
                                                  </h4>
                                                </div>
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t("Customer District")}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el?.district}
                                                  </h4>
                                                </div>
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t("Customer Address")}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el?.address}
                                                  </h4>
                                                </div>
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t("Customer Longitude")}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el?.longitude}
                                                  </h4>
                                                </div>
                                              </div>
                                              {/* line two */}
                                              <div className="gap-[40px] mb-[16px]">
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t("Customer Island")}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el.island}
                                                  </h4>
                                                </div>
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t("Customer Sub District")}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el.sub_district}
                                                  </h4>
                                                </div>
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t(
                                                      "Customer Neighbourhood"
                                                    )}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el.neighbourhood}
                                                  </h4>
                                                </div>
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t("Customer Latitude")}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el.latitude}
                                                  </h4>
                                                </div>
                                              </div>
                                              {/* line 3 */}
                                              <div className="gap-[40px] mb-[16px]">
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t("Customer Province")}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el.province}
                                                  </h4>
                                                </div>
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t(
                                                      "Customer Urban Village"
                                                    )}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el.urban_village}
                                                  </h4>
                                                </div>
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t("Customer Hamlet")}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el.hamlet}
                                                  </h4>
                                                </div>
                                                <div className="w-[500px] mb-[24px]">
                                                  <label className="font-roboto text-[14px] text-[#818181]">
                                                    {t("Customer Postal Code")}
                                                  </label>
                                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                                    {el.postal_code}
                                                  </h4>
                                                </div>
                                              </div>
                                            </div>

                                            <div className="w-[600px] ml-[20px] ">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Pinpoin")}
                                              </label>
                                              {/* {!load ? (
                                                <> */}
                                              <MapsSmall
                                                long={el.longitude}
                                                lat={el.latitude}
                                                onClicks={() =>
                                                  setIsOpenMaps(true)
                                                }
                                              />
                                              {/* </> */}
                                              {/* ) : (
                                                <>
                                                  <Spin
                                                    size="large"
                                                    margin={10}
                                                  />
                                                </>
                                              )} */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                </>
                              }
                            />
                          </div>
                        );
                      })
                    ) : (
                      <></>
                    )}
                    {!addAdr ? (
                      <>
                        <Accordion
                          onClick={() => clickCard("N", isOpen)}
                          index={"N"}
                          i={"N"}
                          isOpen={isOpen}
                          radio={<Radio value={"N"}></Radio>}
                          address={
                            form?.address ? form?.address : "New Address"
                          }
                          body={
                            <>
                              {isOpen === true && "N" === index ? (
                                <>
                                  <ModalMaps
                                    show={isOpenMaps}
                                    address={form?.address}
                                    latitude={form?.latitude}
                                    longitude={form?.longitude}
                                    onClose={() => setIsOpenMaps(false)}
                                  />
                                  <div className="h-auto bg-white-100 opacity-100 rounded-b-lg p-4">
                                    <div className="flex">
                                      <div>
                                        <div className="flex">
                                          {/* line one */}
                                          <div className="gap-[40px] mb-[24px]">

                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {'Recipient Name'}
                                              </label>
                                              <Input
                                                status={
                                                  error?.recipient_name
                                                    ? "error"
                                                    : ""
                                                }
                                                placeholder="Type Recipient Name"
                                                className="mt-[8px] h-[47px] w-[500px]"
                                                value={form?.recipient_name}
                                                onChange={(value) =>
                                                  handleChange(
                                                    value,
                                                    "recipient_name"
                                                  )
                                                }
                                              />
                                              <div className="text-red-100 text-[12px]">
                                                {error?.recipient_name}
                                              </div>
                                            </div>

                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {'Recipient Phone'}
                                              </label>
                                              <Space.Compact>
                                                <Input
                                                  style={{ width: "15%", marginTop: "8px" }}
                                                  defaultValue="+62"
                                                  disabled
                                                />
                                                <Input
                                                  status={
                                                    error?.recipient_phone
                                                      ? "error"
                                                      : ""
                                                  }
                                                  placeholder="Type Recipient Phone"
                                                  className="mt-[8px] h-[47px] w-[500px]"
                                                  value={form?.recipient_phone?.replace('+62-', '')}
                                                  onChange={(value) =>
                                                    handleChange(
                                                      value,
                                                      "recipient_phone"
                                                    )
                                                  }
                                                />
                                              </Space.Compact>
                                              <div className="text-red-100 text-[12px]">
                                                {error?.recipient_phone}
                                              </div>
                                            </div>

                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:CUSTOMER_COUNTRY")}
                                              </label>
                                              <Select
                                                className="w-[500px]"
                                                status={
                                                  error?.country_id
                                                    ? "error"
                                                    : ""
                                                }
                                                dropdownStyle={{
                                                  backgroundColor: "white",
                                                }}
                                                size="large"
                                                onChange={(value) =>
                                                  handleChange(value, "country")
                                                }
                                                // options={country}
                                                value={form?.country}
                                                dropdownRender={(menu) =>
                                                  dropdownCustom(
                                                    menu,
                                                    (value) => onChangeCountry(value),
                                                    searchValue
                                                  )
                                                }
                                              >
                                                {!loading
                                                  ? country
                                                  : [...country, LoadingOption()]}
                                              </Select>
                                              <div className="text-red-100">
                                                {error?.country_id}
                                              </div>
                                            </div>
                                            {/* <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:CUSTOMER_ISLAND")}
                                              </label>
                                              <Select
                                                className="w-[500px]"
                                                status={
                                                  error?.island_id
                                                    ? "error"
                                                    : ""
                                                }
                                                dropdownStyle={{
                                                  backgroundColor: "white",
                                                }}
                                                size="large"
                                                onChange={(value) =>
                                                  handleChange(value, "island")
                                                }
                                                options={island}
                                                value={form?.island}
                                                disabled={!form?.country}
                                              />
                                            </div> */}
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t(
                                                  "CUSTOMER:CUSTOMER_PROVINCE"
                                                )}
                                              </label>
                                              <Select
                                                className="w-[500px]"
                                                status={
                                                  error?.province_id
                                                    ? "error"
                                                    : ""
                                                }
                                                dropdownStyle={{
                                                  backgroundColor: "white",
                                                }}
                                                size="large"
                                                onChange={(value) =>
                                                  handleChange(
                                                    value,
                                                    "province"
                                                  )
                                                }
                                                disabled={!form?.country}
                                                // options={province}
                                                value={form?.province}
                                                onPopupScroll={(e) => onScrollProvince(e)}
                                                loading={loading}
                                                // options={Province}
                                                placeholder="Select Province"
                                                dropdownRender={(menu) =>
                                                  dropdownCustom(
                                                    menu,
                                                    (value) => onChangeProvince(value),
                                                    searchValue
                                                  )
                                                }
                                              >
                                                {!loading ? province : [...province, LoadingOption()]}
                                              </Select>
                                              <div className="text-red-100">
                                                {error?.province_id}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t(
                                                  "CUSTOMER:CUSTOMER_DISTRICT"
                                                )}
                                              </label>
                                              <Select
                                                className="w-[500px]"
                                                status={
                                                  error?.district_id
                                                    ? "error"
                                                    : ""
                                                }
                                                dropdownStyle={{
                                                  backgroundColor: "white",
                                                }}
                                                disabled={!form.province}
                                                size="large"
                                                onChange={(value) =>
                                                  handleChange(
                                                    value,
                                                    "district"
                                                  )
                                                }
                                                // options={district}
                                                value={form?.district}
                                                onPopupScroll={(e) => onScrollDistrict(e)}
                                                loading={loading}
                                                // options={District}
                                                placeholder="Select District"
                                                dropdownRender={(menu) =>
                                                  dropdownCustom(
                                                    menu,
                                                    (value) => onChangeDistrict(value),
                                                    searchValue
                                                  )
                                                }
                                              >
                                                {!loading ? district : [...district, LoadingOption()]}
                                              </Select>
                                              <div className="text-red-100 text-base">
                                                {error?.district_id}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t(
                                                  "CUSTOMER:CUSTOMER_SUB_DISTRICT"
                                                )}
                                              </label>
                                              <Select
                                                className="w-[500px]"
                                                status={
                                                  error?.sub_district_id
                                                    ? "error"
                                                    : ""
                                                }
                                                dropdownStyle={{
                                                  backgroundColor: "white",
                                                }}
                                                size="large"
                                                onChange={(value) =>
                                                  handleChange(
                                                    value,
                                                    "sub_district"
                                                  )
                                                }
                                                // options={subdistrict}
                                                value={form?.sub_district}
                                                disabled={!form?.district}
                                                onPopupScroll={(e) => onScrollSubdistrict(e)}
                                                loading={loading}
                                                // options={Subdistrict}
                                                placeholder="Select Subdistrict"
                                                dropdownRender={(menu) =>
                                                  dropdownCustom(
                                                    menu,
                                                    (value) => onChangeSubdistrict(value),
                                                    searchValue
                                                  )
                                                }
                                              >
                                                {!loading ? subdistrict : [...subdistrict, LoadingOption()]}
                                              </Select>
                                              <div className="text-red-100">
                                                {error?.sub_district_id}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t(
                                                  "CUSTOMER:CUSTOMER_URBAN_VILLAGE"
                                                )}
                                              </label>
                                              <Select
                                                className="w-[500px]"
                                                status={
                                                  error?.urban_village_id
                                                    ? "error"
                                                    : ""
                                                }
                                                dropdownStyle={{
                                                  backgroundColor: "white",
                                                }}
                                                size="large"
                                                onChange={(value) =>
                                                  handleChange(
                                                    value,
                                                    "urban_village"
                                                  )
                                                }
                                                // options={urbanvillage}
                                                value={form?.urban_village}
                                                disabled={!form?.sub_district}
                                                onPopupScroll={(e) => onScrollUrbanvillage(e)}
                                                loading={loading}
                                                // options={Urbanvillage}
                                                placeholder="Select depot Urbanvillage"
                                                dropdownRender={(menu) =>
                                                  dropdownCustom(
                                                    menu,
                                                    (value) => onChangeUrbanvillage(value),
                                                    searchValue
                                                  )
                                                }
                                              >
                                                {!loading ? urbanvillage : [...urbanvillage, LoadingOption()]}
                                              </Select>
                                              <div className="text-red-100 text-base">
                                                {error?.urban_village_id}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:CUSTOMER_ADDRESS")}
                                              </label>
                                              <Input
                                                placeholder="Type Customer Address"
                                                status={
                                                  error?.address || isMax||errAddress
                                                    ? "error"
                                                    : ""
                                                }
                                                onBlur={() => actionBlur(i)}
                                                className="mt-[8px] h-[47px] w-[500px]"
                                                onChange={(value) =>
                                                  handleChange(value, "address")
                                                }
                                                value={form?.address}
                                              />
                                              <label className="text-red-100 text-xs">
                                              {error?.address ? error?.address : errAddress ? errAddress: isMax
                          ? "The Address you entered exceeds the coverage area (" +
                          radius +
                          " Km)"
                           : ""}
                                              </label>
                                            </div>
                                          </div>

                                          {/* LINE TWO */}
                                          <div className="gap-[40px] mb-[24px] ml-36">
                                            <div className="w-[500px] mb-[24px] flex">
                                              <div>
                                                <label className="font-roboto text-[16px] font-medium">
                                                  {t("CUSTOMER:HAMLET")}{" "}
                                                  <i>(Optional)</i>
                                                </label>
                                                <Input
                                                  status={
                                                    error?.hamlet ? "error" : ""
                                                  }
                                                  placeholder="Type Hamlet"
                                                  className="mt-[8px] h-[47px] w-[200px]"
                                                  onChange={(value) =>
                                                    handleChange(
                                                      value,
                                                      "hamlet"
                                                    )
                                                  }
                                                  value={form?.hamlet}
                                                />
                                                <div className="text-red-100">
                                                  {error?.hamlet}
                                                </div>
                                              </div>
                                              <div>
                                                <label className="font-roboto text-[16px] font-medium">
                                                  {t("CUSTOMER:NEIGHBOURHOOD")}{" "}
                                                  <i>(Optional)</i>
                                                </label>
                                                <Input
                                                  status={
                                                    error?.neighbourhood
                                                      ? "error"
                                                      : ""
                                                  }
                                                  placeholder="Type Neighbourhood"
                                                  className="mt-[8px] h-[47px] w-[200px]"
                                                  onChange={(value) =>
                                                    handleChange(
                                                      value,
                                                      "neighbourhood"
                                                    )
                                                  }
                                                  value={form?.neighbourhood}
                                                />
                                                <div className="text-red-100">
                                                  {error?.neighbourhood}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:POSTAL_CODE")}
                                              </label>
                                              <Input
                                                status={
                                                  error?.postal_code ||
                                                    errPostal
                                                    ? "error"
                                                    : ""
                                                }
                                                onBlur={() => onBlurPostal()}
                                                placeholder="Type Postal Code"
                                                className="mt-[8px] h-[47px] w-[500px]"
                                                value={form.postal_code}
                                                onChange={(value) =>
                                                  handleChange(
                                                    value,
                                                    "postal_code"
                                                  )
                                                }
                                              />
                                              <div className="text-red-100 text-xs">
                                                {error?.postal_code ||
                                                  errPostal}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:LONGITUDE")}
                                              </label>
                                              <Input
                                                status={
                                                  error?.longitude
                                                    ? "error"
                                                    : ""
                                                }
                                                placeholder="Type Longitude"
                                                className="mt-[8px] h-[47px] w-[500px]"
                                                onChange={(value) =>
                                                  handleChange(
                                                    value,
                                                    "longitude"
                                                  )
                                                }
                                                value={form?.longitude}
                                                disabled
                                              />
                                              <div className="text-red-100">
                                                {error?.longitude}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:LATITUDE")}
                                              </label>
                                              <Input
                                                status={
                                                  error?.latitude ? "error" : ""
                                                }
                                                placeholder="Type Latitude"
                                                className="mt-[8px] h-[47px] w-[500px]"
                                                onChange={(value) =>
                                                  handleChange(
                                                    value,
                                                    "latitude"
                                                  )
                                                }
                                                disabled
                                                value={form?.latitude}
                                              />
                                              <div className="text-red-100">
                                                {error?.latitude}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[100px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:PINPOIN")}
                                              </label>
                                              <div className="w-[500px] mb-[24px] h-20">
                                                {!load ? (
                                                  <>
                                                    <MapsSmall
                                                      long={form.longitude}
                                                      lat={form.latitude}
                                                      onClicks={() =>
                                                        setIsOpenMaps(true)
                                                      }
                                                    />
                                                  </>
                                                ) : (
                                                  <>
                                                    <Spin
                                                      size="large"
                                                      margin={10}
                                                    />
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex flex-row-reverse gap-[16px] pb-8 mr-8">
                                    <button
                                      className="min-w-[87px] h-[44px] gap-3 px-[16px] bg-[#CF0000] text-white-100 text-xl flex items-center justify-evenly rounded-md"
                                      onClick={() => addAddress()}
                                    >
                                      Add
                                    </button>
                                    <button
                                      onClick={() => removeAddress()}
                                      className="w-[87px] h-[44px] text-[#CF0000] border-[2px] border-[#CF0000] bg-white-100 text-xl flex items-center justify-evenly rounded-md"
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </>
                              ) : null}
                            </>
                          }
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </Radio.Group>
                </div>
                {form.customer_id && addAdr ? (
                  <>
                    <div
                      className="p-5"
                      style={{ marginBottom: "20px", width: "100%" }}
                    >
                      <div
                        className={`h-[40px] ${add ? "bg-red-100" : "bg-gray-100"
                          }  opacity-100 rounded-lg cursor-pointer justify-center flex`}
                        onClick={addAdr ? () => addRowsAdr() : ""}
                      >
                        <img src={AddIcon} alt="add" />
                        <div className="text-white-100 font-semibold text-2xl ml-2 mt-1">
                          Add New Address
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                <div className="flex">
                  {/* line one */}
                  <div className="gap-[40px] mb-[24px]">
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("CUSTOMER:FIRST_NAME")}
                      </label>
                      <Input
                        className="mt-[8px] h-[47px] w-[500px]"
                        onChange={(value) => handleChange(value, "first_name")}
                        status={error?.first_name ? "error" : ""}
                        value={form.first_name}
                      />

                      <div className="text-red-100">{error?.first_name}</div>
                    </div>

                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("CUSTOMER:LAST_NAME") + " (Optional)"}
                      </label>
                      <Input
                        className="mt-[8px] h-[47px] w-[500px]"
                        onChange={(value) => handleChange(value, "last_name")}
                        status={error?.last_name ? "error" : ""}
                        value={form.last_name}
                      />

                      <div className="text-red-100">{error?.last_name}</div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-base font-medium">
                        {t("CUSTOMER:PHONE")}
                      </label>
                      <Space.Compact>
                        <Input
                          style={{ width: "15%" }}
                          defaultValue="+62"
                          disabled
                        />
                        <Input
                          style={{ width: "480px", height: "47px" }}
                          onChange={(value) => handleChange(value, "phone")}
                          status={error?.phone ? "error" : ""}
                          value={form.phone}
                        />
                      </Space.Compact>
                      <div className="text-red-100">{error?.phone}</div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-base font-medium">
                        {t("CUSTOMER:EMAIL") + " (Optional)"}
                      </label>
                      <Input
                        status={error?.email ? "error" : ""}
                        placeholder="Type Email"
                        className="mt-[8px] h-[47px] w-[500px]"
                        value={form?.email}
                        onChange={(value) => handleChange(value, "email")}
                      />
                      <div className="text-red-100">{error?.email}</div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-base font-medium">
                        {t("CUSTOMER:FAX") + " (Optional)"}
                      </label>
                      <Space.Compact>
                        <Input
                          style={{ width: "15%" }}
                          defaultValue="+62"
                          disabled
                        />
                        <Input
                          style={{ width: "480px", height: "47px" }}
                          status={error?.fax ? "error" : ""}
                          placeholder="Type Fax"
                          value={form?.fax}
                          onChange={(value) => handleChange(value, "fax")}
                        />
                      </Space.Compact>
                      <div className="text-red-100">{error?.fax}</div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-base font-medium">
                        {'Recipient Name'}
                      </label>
                      <Input
                        status={
                          error?.recipient_name
                            ? "error"
                            : ""
                        }
                        placeholder="Type Recipient Name"
                        className="mt-[8px] h-[47px] w-[500px]"
                        value={form?.recipient_name}
                        onChange={(value) =>
                          handleChange(
                            value,
                            "recipient_name"
                          )
                        }
                      />
                      <div className="text-red-100 text-[12px]">
                        {error?.recipient_name}
                      </div>
                    </div>

                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-base font-medium">
                        {'Recipient Phone'}
                      </label>
                      <Space.Compact>
                        <Input
                          style={{ width: "15%", marginTop: "8px" }}
                          defaultValue="+62"
                          disabled
                        />
                        <Input
                          status={
                            error?.recipient_phone
                              ? "error"
                              : ""
                          }
                          placeholder="Type Recipient Phone"
                          className="mt-[8px] h-[47px] w-[480px]"
                          value={form?.recipient_phone}
                          onChange={(value) =>
                            handleChange(
                              value,
                              "recipient_phone"
                            )
                          }
                        />
                      </Space.Compact>
                      <div className="text-red-100 text-[12px]">
                        {error?.recipient_phone}
                      </div>
                    </div>
                  </div>
                  {/* line two */}
                  <div className="gap-[40px] mb-[24px] ml-10">
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("CUSTOMER:CUSTOMER_COUNTRY")}
                      </label>
                      <Select
                        className="w-[500px]"
                        status={error?.country_id ? "error" : ""}
                        dropdownStyle={{
                          backgroundColor: "white",
                        }}
                        size="large"
                        value={form.country}
                        onChange={(value) => handleChange(value, "country")}
                        // options={country}
                        dropdownRender={(menu) =>
                          dropdownCustom(
                            menu,
                            (value) => onChangeCountry(value),
                            searchValue
                          )
                        }
                      >
                        {!loading
                          ? country
                          : [...country, LoadingOption()]}
                      </Select>
                      <div className="text-red-100">{error?.country_id}</div>
                    </div>
                    {/* <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("CUSTOMER:CUSTOMER_ISLAND") + " (Optional)"}
                      </label>
                      <Select
                        className="w-[500px]"
                        disabled={!form.country}
                        status={error?.island_id ? "error" : ""}
                        dropdownStyle={{
                          backgroundColor: "white",
                        }}
                        size="large"
                        value={form.island}
                        onChange={(value) => handleChange(value, "island")}
                        options={island}
                      />
                      <div className="text-red-100">{error?.island_id}</div>
                    </div> */}
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("CUSTOMER:CUSTOMER_PROVINCE")}
                      </label>
                      <Select
                        className="w-[500px]"
                        disabled={!form.country}
                        value={form.province}
                        status={error?.province_id ? "error" : ""}
                        dropdownStyle={{
                          backgroundColor: "white",
                        }}
                        size="large"
                        onChange={(value) => handleChange(value, "province")}
                        onPopupScroll={(e) => onScrollProvince(e)}
                        loading={loading}
                        // options={Province}
                        placeholder="Select Province"
                        dropdownRender={(menu) =>
                          dropdownCustom(
                            menu,
                            (value) => onChangeProvince(value),
                            searchValue
                          )
                        }
                      >
                        {!loading ? province : [...province, LoadingOption()]}
                      </Select>
                      <div className="text-red-100">{error?.province_id}</div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("CUSTOMER:CUSTOMER_DISTRICT")}
                      </label>
                      <Select
                        className="w-[500px]"
                        status={error?.district_id ? "error" : ""}
                        dropdownStyle={{
                          backgroundColor: "white",
                        }}
                        disabled={!form.province}
                        value={form.district}
                        size="large"
                        onChange={(value) => handleChange(value, "district")}
                        onPopupScroll={(e) => onScrollDistrict(e)}
                        loading={loading}
                        // options={District}
                        placeholder="Select District"
                        dropdownRender={(menu) =>
                          dropdownCustom(
                            menu,
                            (value) => onChangeDistrict(value),
                            searchValue
                          )
                        }
                      >
                        {!loading ? district : [...district, LoadingOption()]}
                      </Select>
                      <div className="text-red-100">{error?.district_id}</div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("CUSTOMER:CUSTOMER_SUB_DISTRICT")}
                      </label>
                      <Select
                        className="w-[500px]"
                        status={error?.sub_district_id ? "error" : ""}
                        dropdownStyle={{
                          backgroundColor: "white",
                        }}
                        size="large"
                        disabled={!form.district}
                        value={form.sub_district}
                        onChange={(value) =>
                          handleChange(value, "sub_district")
                        }
                        onPopupScroll={(e) => onScrollSubdistrict(e)}
                        loading={loading}
                        // options={Subdistrict}
                        placeholder="Select Subdistrict"
                        dropdownRender={(menu) =>
                          dropdownCustom(
                            menu,
                            (value) => onChangeSubdistrict(value),
                            searchValue
                          )
                        }
                      >
                        {!loading ? subdistrict : [...subdistrict, LoadingOption()]}
                      </Select>
                      <div className="text-red-100">
                        {error?.sub_district_id}
                      </div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("CUSTOMER:CUSTOMER_URBAN_VILLAGE")}
                      </label>
                      <Select
                        className="w-[500px]"
                        status={error?.urban_village_id ? "error" : ""}
                        dropdownStyle={{
                          backgroundColor: "white",
                        }}
                        size="large"
                        disabled={!form.sub_district}
                        value={form.urban_village}
                        onChange={(value) =>
                          handleChange(value, "urban_village")
                        }
                        onPopupScroll={(e) => onScrollUrbanvillage(e)}
                        loading={loading}
                        // options={Urbanvillage}
                        placeholder="Select depot Urbanvillage"
                        dropdownRender={(menu) =>
                          dropdownCustom(
                            menu,
                            (value) => onChangeUrbanvillage(value),
                            searchValue
                          )
                        }
                      >
                        {!loading ? urbanvillage : [...urbanvillage, LoadingOption()]}
                      </Select>
                      <div className="text-red-100">
                        {error?.urban_village_id}
                      </div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("CUSTOMER:CUSTOMER_ADDRESS")}
                      </label>
                      <Input
                        className="mt-[8px] h-[47px] w-[500px]"
                        onChange={(value) => handleChange(value, "address")}
                        status={error?.address || isMax||errAddress ? "error" : ""}
                        value={form.address}
                        onBlur={() => actionBlur()}
                      />
                      <div className="text-red-100">
                        {error?.address ? error?.address: errAddress ? errAddress : isMax
                          ? "The Address you entered exceeds the coverage area (" +
                          radius +
                          " Km)"
                          : ""}
                      </div>
                    </div>
                    <div className="w-[500px] mb-[24px] flex">
                      <div>
                        <label className="font-roboto text-[16px] font-medium">
                          {t("CUSTOMER:HAMLET") + " (Optional)"}
                        </label>
                        <Input
                          className="mt-[8px] h-[47px] w-[200px]"
                          onChange={(value) => handleChange(value, "hamlet")}
                          status={error?.hamlet ? "error" : ""}
                          value={form.hamlet}
                        />

                        <div className="text-red-100">{error?.hamlet}</div>
                      </div>
                      <div>
                        <label className="font-roboto text-[16px] font-medium">
                          {t("CUSTOMER:NEIGHBOURHOOD") + " (Optional)"}
                        </label>
                        <Input
                          className="mt-[8px] h-[47px] w-[200px]"
                          onChange={(value) =>
                            handleChange(value, "neighbourhood")
                          }
                          status={error?.neighbourhood ? "error" : ""}
                          value={form.neighbourhood}
                        />

                        <div className="text-red-100">
                          {error?.neighbourhood}
                        </div>
                      </div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-base font-medium">
                        {t("CUSTOMER:POSTAL_CODE")}
                      </label>
                      <Input
                        status={error?.postal_code || errPostal ? "error" : ""}
                        onBlur={() => onBlurPostal()}
                        placeholder="Type Postal Code"
                        className="mt-[8px] h-[47px] w-[500px]"
                        value={form.postal_code}
                        onChange={(value) => handleChange(value, "postal_code")}
                      />
                      <div className="text-red-100">
                        {error?.postal_code || errPostal}
                      </div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("CUSTOMER:LONGITUDE")}
                      </label>
                      <Input
                        className="mt-[8px] h-[47px] w-[500px]"
                        onChange={(value) => handleChange(value, "longitude")}
                        status={error?.longitude ? "error" : ""}
                        value={form.longitude}
                        disabled
                      />

                      <div className="text-red-100">{error?.longitude}</div>
                    </div>
                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("CUSTOMER:LATITUDE")}
                      </label>
                      <Input
                        className="mt-[8px] h-[47px] w-[500px]"
                        onChange={(value) => handleChange(value, "latitude")}
                        status={error?.latitude ? "error" : ""}
                        value={form.latitude}
                        disabled
                      />

                      <div className="text-red-100">{error?.latitude}</div>
                    </div>
                    <div className="w-[500px] mb-[100px]">
                      <label className="font-roboto text-base font-medium">
                        {t("CUSTOMER:PINPOIN")}
                      </label>
                      <div className="w-[500px] mb-[35px] h-20">
                        {!load ? (
                          <>
                            <MapsSmall
                              long={form.longitude}
                              lat={form.latitude}
                              onClicks={() => setIsOpenMaps(true)}
                            />
                          </>
                        ) : (
                          <>
                            <Spin size="large" margin={10} />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </>
    );
  };

  const page3 = () => {
    return (
      <>
        <div className="flex">
          {/* line one */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[500px] mb-[24px]">
              <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                {t("Order Information")}
              </h3>
            </div>
            <div className="w-[500px] mb-[24px]">
              <label className="font-roboto text-[16px] font-medium">
                {t("Priority Delivery")}
              </label>
              <Select
                className="w-[500px]"
                dropdownStyle={{
                  backgroundColor: "white",
                }}
                size="large"
                value={form.order_priority}
                status={error?.order_priority ? "error" : ""}
                onChange={(value) => handleChange(value, "order_priority")}
                options={prioDeliv}
              />
              <div className="text-red-100">{error?.order_priority}</div>
            </div>
            <div className="w-[500px] mb-[24px]">
              <label className="font-roboto text-[16px] font-medium">
                {t("Delivery Type")}
              </label>
              <Select
                className="w-[500px]"
                dropdownStyle={{
                  backgroundColor: "white",
                }}
                size="large"
                value={form.delivery_type_id}
                status={error?.delivery_type_id ? "error" : ""}
                onChange={(value) => handleChange(value, "delivery_type_id")}
                // options={deliveryType}
                onPopupScroll={(e) => onScrollDeliveryType(e)}
                    loading={loading}
                    // options={DeliveryType}
                    placeholder="Select DeliveryType"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeDeliveryType(value),
                        searchValue
                      )
                    }
              >
              {!loading ? deliveryType : [...deliveryType]}
                </Select>
              <div className="text-red-100">{error?.delivery_type_id}</div>
            </div>
            <div className="w-[500px] mb-[24px]">
              <label className="font-roboto text-base font-medium">
                {t("Total Order Weight")}
              </label>
              <Space.Compact>
                <Input
                  style={{
                    width: "480px",
                    height: "47px",
                    marginTop: "8px",
                  }}
                  // placeholder="1000"
                  disabled
                  value={subWeight?.reduce((acc, curr) => acc + curr)}
                // value={()=>getTotal()}
                />

                <Input
                  style={{ width: "15%", marginTop: "8px" }}
                  value="Kg"
                  disabled
                />
              </Space.Compact>
            </div>
            <div className="w-[500px] mb-[24px]">
              <label className="font-roboto text-base font-medium">
                {t("Total Order Volume")}
              </label>
              <Space.Compact>
                <Input
                  style={{
                    width: "480px",
                    height: "47px",
                    marginTop: "8px",
                  }}
                  // placeholder="1000"
                  disabled
                  value={subVol?.reduce((acc, curr) => acc + curr)}
                />

                <Input
                  style={{ width: "15%", marginTop: "8px" }}
                  value="m2"
                  disabled
                />
              </Space.Compact>
            </div>
            <div className="w-[500px] mb-[24px]">
              <label className="font-roboto text-[16px] font-medium">
                {t("Delivery Note") + " (Optional)"}
              </label>
              <Input
                className="mt-[8px] h-[47px] w-[500px]"
                onChange={(value) => handleChange(value, "delivery_notes")}
                status={error?.delivery_notes ? "error" : ""}
                value={form.delivery_notes}
              />

              <div className="text-red-100">{error?.delivery_notes}</div>
            </div>
          </div>
          {/* line two */}
          <div className="gap-[40px] mb-[24px] ml-20 mt-10">
            <div className="w-[500px] mb-[24px]">
              <label className="font-roboto text-[16px] font-medium">
                {t("Total Price")}
              </label>
              <Space.Compact>
                <Input style={{ width: "15%" }} defaultValue="IDR" disabled />
                <Input
                  style={{ width: "480px", height: "47px" }}
                  placeholder="1000"
                  disabled
                // onChange={(value) => handleChange(value, "total_price")}
                // status={error?.total_price ? "error" : ""}
                value={form.total_price ? form.total_price : 0}
                />
              </Space.Compact>

              {/* <div className="text-red-100">{error?.total_price}</div> */}
            </div>
          </div>
        </div>
      </>
    );
  };

  const actModal = () => {
    setSuccessModalOpen(false);
    navigate({
      pathname: ROUTES.ORDER_REQUEST.LIST,
    });
  };

  return (
    <>
      <ModalMaps
        show={isOpenMaps}
        address={form.address}
        latitude={form.latitude}
        longitude={form.longitude}
        onClose={() => setIsOpenMaps(false)}
      />
      <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.ORDER_REQUEST.LIST}
      />
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been added"
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => setFailedModalOpen(false)}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be added"
        description={"Length and width cannot bigger than pallet"}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>Order</Breadcrumb.Item>
            <Breadcrumb.Item>Order Request</Breadcrumb.Item>
            <Breadcrumb.Item>Add Order Request</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="flex items-center justify-between">
          <div
            onClick={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.ORDER_REQUEST.LIST)
            }
            className="flex items-center gap-[22px] cursor-pointer"
          >
            <img src={BackIcon} alt="" className="cursor-pointer" />

            <h1 className="font-sans-bold text-[28px]" id="title">
              Add Order Request
            </h1>
          </div>
        </div>

        <div
          // onClick={index === "N"||custCat === "new" ?() => getDistance() : ""}
          // onClick={() =>
          //   index === "N" || custCat === "new" ? getDistance() : ""
          // }
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <img
              src={page === 1 ? OrderStep : page === 2 ? DelivStep : TotalStep}
              alt="tab"
            />
            {/* <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            /> */}
            {
            // !load
            //   ? 
              page === 1
                ? page1()
                : page === 2
                  ? page2()
                  : page3()
              // : "loading..."
              }
          </div>
        </div>

        <div className="flex flex-row-reverse gap-[16px]">
          {page === 1 ? (
            <>
              <PrimaryButton
                text={t("COMMON:NEXT")}
                action={changeItem || !isData ? "" : () => handleNext()}
                styles={`${changeItem || !isData ? " bg-gray-100" : ""}`}
              />
              <SecondaryButton
                action={
                  change
                    ? () => setShowConfirm(true)
                    : () => navigate(ROUTES.ORDER_REQUEST.LIST)
                }
                text={t("USER_DETAIL:CANCEL")}
              />
            </>
          ) : page === 2 ? (
            <>
              <PrimaryButton
                text={t("COMMON:NEXT")}
                action={() => handleNext2()}
              />
              <SecondaryButton text={t("Previous")} action={() => setPage(1)} />
            </>
          ) : (
            <>
              <PrimaryButton
                text={t("USER_DETAIL:SAVE")}
                action={() => onSubmit()}
              />
              <SecondaryButton text={t("Previous")} action={() => setPage(2)} />
            </>
          )}
          {/* <PrimaryButton text={t("COMMON:NEXT")} />
          <SecondaryButton text={t("USER_DETAIL:CANCEL")} /> */}
        </div>
      </div>
    </>
  );
};
export default OrderRequestAdd;
